// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/card-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23949ba3%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 13.1l-8-8 2.1-2.2 5.9 5.9 5.9-5.9 2.1 2.2z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.border-theme-white {
  border: 1px solid var(--bs-theme-white-color);
}

.border-theme-white-2 {
  border: 2px solid var(--bs-theme-white-color);
}

.breadcrumb-item + .breadcrumb-item:before {
  content: "\\f101";
  font-family: "Line Awesome Free";
  font-weight: 900;
}

.btn-primary {
  -webkit-box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);
          box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);
}
.btn-primary:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-secondary {
  -webkit-box-shadow: 0 1px 2px 0 rgba(168, 181, 209, 0.35);
          box-shadow: 0 1px 2px 0 rgba(168, 181, 209, 0.35);
}
.btn-secondary:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-success {
  -webkit-box-shadow: 0 1px 2px 0 rgba(13, 166, 132, 0.35);
          box-shadow: 0 1px 2px 0 rgba(13, 166, 132, 0.35);
}
.btn-success:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-info {
  -webkit-box-shadow: 0 1px 2px 0 rgba(65, 203, 216, 0.35);
          box-shadow: 0 1px 2px 0 rgba(65, 203, 216, 0.35);
}
.btn-info:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-warning {
  -webkit-box-shadow: 0 1px 2px 0 rgba(244, 161, 77, 0.35);
          box-shadow: 0 1px 2px 0 rgba(244, 161, 77, 0.35);
}
.btn-warning:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-danger {
  -webkit-box-shadow: 0 1px 2px 0 rgba(239, 52, 99, 0.35);
          box-shadow: 0 1px 2px 0 rgba(239, 52, 99, 0.35);
}
.btn-danger:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-pink {
  -webkit-box-shadow: 0 1px 2px 0 rgba(253, 60, 151, 0.35);
          box-shadow: 0 1px 2px 0 rgba(253, 60, 151, 0.35);
}
.btn-pink:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-purple {
  -webkit-box-shadow: 0 1px 2px 0 rgba(91, 88, 230, 0.35);
          box-shadow: 0 1px 2px 0 rgba(91, 88, 230, 0.35);
}
.btn-purple:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-blue {
  -webkit-box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);
          box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);
}
.btn-blue:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-light {
  -webkit-box-shadow: 0 1px 2px 0 rgba(244, 246, 249, 0.35);
          box-shadow: 0 1px 2px 0 rgba(244, 246, 249, 0.35);
}
.btn-light:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-dark {
  -webkit-box-shadow: 0 1px 2px 0 rgba(37, 40, 45, 0.35);
          box-shadow: 0 1px 2px 0 rgba(37, 40, 45, 0.35);
}
.btn-dark:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.btn-soft-primary {
  background-color: rgba(49, 103, 243, 0.15);
  color: #3167f3;
}
.btn-soft-primary:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #3167f3;
  color: #ffffff;
}

.btn-soft-secondary {
  background-color: rgba(168, 181, 209, 0.15);
  color: #a8b5d1;
}
.btn-soft-secondary:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #a8b5d1;
  color: #ffffff;
}

.btn-soft-success {
  background-color: rgba(13, 166, 132, 0.15);
  color: #0da684;
}
.btn-soft-success:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #0da684;
  color: #ffffff;
}

.btn-soft-info {
  background-color: rgba(65, 203, 216, 0.15);
  color: #41cbd8;
}
.btn-soft-info:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #41cbd8;
  color: #ffffff;
}

.btn-soft-warning {
  background-color: rgba(244, 161, 77, 0.15);
  color: #f4a14d;
}
.btn-soft-warning:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #f4a14d;
  color: #ffffff;
}

.btn-soft-danger {
  background-color: rgba(239, 52, 99, 0.15);
  color: #ef3463;
}
.btn-soft-danger:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #ef3463;
  color: #ffffff;
}

.btn-soft-pink {
  background-color: rgba(253, 60, 151, 0.15);
  color: #fd3c97;
}
.btn-soft-pink:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #fd3c97;
  color: #ffffff;
}

.btn-soft-purple {
  background-color: rgba(91, 88, 230, 0.15);
  color: #5b58e6;
}
.btn-soft-purple:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #5b58e6;
  color: #ffffff;
}

.btn-soft-blue {
  background-color: rgba(49, 103, 243, 0.15);
  color: #3167f3;
}
.btn-soft-blue:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #3167f3;
  color: #ffffff;
}

.btn-soft-light {
  background-color: rgba(244, 246, 249, 0.15);
  color: #f4f6f9;
}
.btn-soft-light:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #f4f6f9;
  color: #ffffff;
}

.btn-soft-dark {
  background-color: rgba(37, 40, 45, 0.15);
  color: #25282d;
}
.btn-soft-dark:hover {
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: #25282d;
  color: #ffffff;
}

.text-gray-100 {
  color: #f4f6f9;
}

.text-gray-200 {
  color: #eaeff5;
}

.text-gray-300 {
  color: #d9e1ec;
}

.text-gray-400 {
  color: #c1cde0;
}

.text-gray-500 {
  color: #a8b5d1;
}

.text-gray-600 {
  color: #95a0c5;
}

.text-gray-700 {
  color: #7a82b1;
}

.text-gray-800 {
  color: #555b7e;
}

.text-gray-900 {
  color: #25282d;
}

.btn-outline-light {
  color: #7a82b1;
  background-image: none;
  background-color: transparent;
  border-color: #d9e1ec;
}

.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  border-color: transparent;
}

.modal-header .btn-close {
  font-size: 20px;
}

html[data-bs-theme=dark] .btn-light {
  -webkit-box-shadow: none;
          box-shadow: none;
  --bs-btn-color: #f4f6f9;
  --bs-btn-bg: #303231;
  --bs-btn-border-color: #2b2d3b;
  --bs-btn-hover-color: #f4f6f9;
  --bs-btn-hover-bg: #343635;
  --bs-btn-hover-border-color: #313341;
  --bs-btn-focus-shadow-rgb: 75, 77, 88;
  --bs-btn-active-color: #f4f6f9;
  --bs-btn-active-bg: #343635;
  --bs-btn-active-border-color: #313341;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #f4f6f9;
  --bs-btn-disabled-bg: #2b2d3b;
  --bs-btn-disabled-border-color: #2b2d3b;
}
html[data-bs-theme=dark] .btn-dark {
  --bs-btn-color: #303231;
  --bs-btn-bg: #f4f6f9;
  --bs-btn-border-color: #f4f6f9;
  --bs-btn-hover-color: #303231;
  --bs-btn-hover-bg: #e8eaed;
  --bs-btn-hover-border-color: #dcdde0;
  --bs-btn-focus-shadow-rgb: 207, 209, 212;
  --bs-btn-active-color: #303231;
  --bs-btn-active-bg: #dcdde0;
  --bs-btn-active-border-color: #cfd1d4;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #303231;
  --bs-btn-disabled-bg: #f4f6f9;
  --bs-btn-disabled-border-color: #f4f6f9;
}
html[data-bs-theme=dark] .btn-outline-light {
  color: #c1cde0;
  background-image: none;
  background-color: transparent;
  border-color: #555b7e;
}
html[data-bs-theme=dark] .btn-outline-light:active {
  color: #eaeff5;
  background-image: none;
  background-color: transparent;
  border-color: #7a82b1;
}

.card {
  -webkit-box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.03);
          box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.03);
  margin-bottom: 1.5rem;
}
.card .card-header {
  border-bottom: none;
  padding-top: var(--bs-card-spacer-x);
}
.card .card-header .card-title {
  margin-bottom: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--bs-heading-color);
}

.card-h-100 {
  height: calc(100% - 1.5rem);
}

.offer-card {
  /*background-image: url("../images/extra/pet-bg.png");*/
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #000000;
}

.dropdown-menu {
  -webkit-box-shadow: 0 5px 5px rgba(61, 71, 81, 0.1);
          box-shadow: 0 5px 5px rgba(61, 71, 81, 0.1);
}

.dropstart .dropdown-toggle::before,
.dropend .dropdown-toggle::after,
.dropup .dropdown-toggle::after,
.dropdown-toggle::after {
  display: none;
}

.dropdown-lg {
  width: 320px;
}

label {
  color: var(--bs-label-color);
  vertical-align: middle;
}

.ql-editor {
  min-height: 300px;
  font-family: var(--bs-font-sans-serif) !important;
}

.ql-snow .ql-stroke {
  stroke: var(--bs-label-color);
}
.ql-snow .ql-picker-options {
  background-color: var(--bs-topbar-bg);
}
.ql-snow .ql-picker.ql-header .ql-picker-label:before,
.ql-snow .ql-picker.ql-header .ql-picker-item:before {
  color: var(--bs-label-color);
}

.ql-toolbar {
  font-family: var(--bs-font-sans-serif) !important;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
  border: 1px solid var(--bs-border-color);
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: var(--bs-border-color);
}

.ql-container.ql-snow {
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border: 1px solid var(--bs-border-color);
}

.uppy-Root {
  font-family: var(--bs-font-sans-serif) !important;
}

.uppy-DragDrop-container {
  background-color: var(--bs-secondary-bg);
}

.uppy-Dashboard-inner {
  background-color: var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color);
  height: 250px !important;
}

[data-uppy-drag-drop-supported=true] .uppy-Dashboard-AddFiles {
  border: 1px dashed var(--bs-border-color);
}

.uppy-Dashboard-AddFiles-title {
  color: var(--bs-body-color);
}

.uppy-DragDrop-container:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.uppy-DragDrop--isDragDropSupported {
  border: 2px dashed #d9e1ec;
}

.uppy-DragDrop-label {
  color: #25282d;
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actions {
  background-color: var(--bs-card-bg);
}

.uppy-StatusBar:not([aria-hidden=true]).is-waiting {
  border-top: 1px solid var(--bs-border-color);
}

.uppy-Dashboard-Item-name,
.uppy-DashboardContent-title {
  color: var(--bs-label-color);
}

.uppy-StatusBar,
.uppy-DashboardContent-bar {
  background-color: var(--bs-card-bg);
  border-bottom: 1px solid var(--bs-border-color);
}

.uppy-Dashboard-Item {
  border-bottom: 1px solid var(--bs-border-color);
}

.uppy-Dashboard-Item-action--remove {
  color: #3167f3;
}
.uppy-Dashboard-Item-action--remove:hover, .uppy-Dashboard-Item-action--remove:focus {
  color: #1955f2;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.uppy-DashboardContent-addMore:focus,
.uppy-DashboardContent-back:focus,
.uppy-DashboardContent-save:focus {
  background-color: rgba(168, 181, 209, 0.1);
}

.uppy-c-btn-primary:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}

input.add-file-input {
  position: absolute;
  opacity: 0;
  right: 0;
  top: 0;
}

.form-switch-primary .form-check-input:checked {
  background-color: #3167f3;
  border-color: #3167f3;
}

.form-switch-secondary .form-check-input:checked {
  background-color: #a8b5d1;
  border-color: #a8b5d1;
}

.form-switch-success .form-check-input:checked {
  background-color: #0da684;
  border-color: #0da684;
}

.form-switch-info .form-check-input:checked {
  background-color: #41cbd8;
  border-color: #41cbd8;
}

.form-switch-warning .form-check-input:checked {
  background-color: #f4a14d;
  border-color: #f4a14d;
}

.form-switch-danger .form-check-input:checked {
  background-color: #ef3463;
  border-color: #ef3463;
}

.form-switch-pink .form-check-input:checked {
  background-color: #fd3c97;
  border-color: #fd3c97;
}

.form-switch-purple .form-check-input:checked {
  background-color: #5b58e6;
  border-color: #5b58e6;
}

.form-switch-blue .form-check-input:checked {
  background-color: #3167f3;
  border-color: #3167f3;
}

.form-switch-light .form-check-input:checked {
  background-color: #f4f6f9;
  border-color: #f4f6f9;
}

.form-switch-dark .form-check-input:checked {
  background-color: #25282d;
  border-color: #25282d;
}

.selectr-option {
  padding: 0.375rem 1.5rem;
  color: var(--bs-dropdown-link-color);
  background-color: transparent;
}
.selectr-option.selected {
  background-color: var(--bs-light);
}
.selectr-option:hover {
  color: var(--bs-body-color);
  background-color: var(--bs-light);
}
.selectr-option.active {
  color: var(--bs-body-color);
  background-color: var(--bs-light);
  text-decoration: none;
}

.selectr-options-container,
.selectr-selected {
  width: 100%;
  padding: 0.517rem 0.95rem;
  font-size: 0.812rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-body-color);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--bs-card-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.selectr-container.multiple.has-selected .selectr-selected {
  padding: 0 0.95rem;
  padding-top: calc(0.517rem - 2px);
  padding-bottom: calc(0.517rem - 2px);
}
.selectr-container.multiple.has-selected .selectr-selected:focus-visible {
  outline: none;
}
.selectr-container.open .selectr-selected {
  border-color: var(--bs-border-color) var(--bs-border-color) transparent;
  border-radius: 3px 3px 0 0;
}
.selectr-container.open .selectr-selected:focus-visible {
  outline: none;
}

.selectr-tag-input {
  background-color: var(--bs-card-bg);
  padding: 0;
}
.selectr-tag-input:focus-visible {
  outline: none;
}

.taggable .selectr-selected {
  padding: 0.517rem 0.95rem;
}

.selectr-input {
  border-color: var(--bs-border-color) !important;
  background-color: var(--bs-card-bg);
}
.selectr-input:focus-visible {
  outline: none;
}

.selectr-tag {
  background: #3167f3;
  border-radius: 3px;
}

.selectr-tag-remove::after,
.selectr-tag-remove::before {
  width: 1px;
}

.datepicker.active {
  display: inline-block;
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
}

.datepicker-dropdown.datepicker-orient-top {
  padding-bottom: 0;
}

.datepicker-header .datepicker-controls .button {
  font-weight: 500;
}

.datepicker-controls .button {
  font-size: 15px;
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-body-bg);
  color: #7a82b1;
}

.datepicker-view .dow {
  font-weight: 500;
  font-size: 12px;
}

.datepicker-picker {
  background-color: var(--bs-body-bg);
}
.datepicker-picker span {
  border-radius: 25px;
}

.datepicker-cell.focused:not(.selected),
.datepicker-cell:not(.disabled):hover {
  background-color: #3167f3;
  color: #ffffff;
}

.example__complete {
  display: none;
  margin-left: 5px;
}

.example__complete::after {
  content: "✔";
}

#form-validation-2 small {
  display: none;
  color: #ef3463;
}
#form-validation-2 small.error {
  display: block;
}

.form-control.error {
  border-color: #ef3463;
}
.form-control.success {
  border-color: #0da684;
}

.preview-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 100%;
  height: auto;
}
.preview-box .preview-content {
  width: auto;
  height: 50px;
  max-width: 100%;
  border-radius: 5px;
}

.dynamic-select .dynamic-select-header {
  border: none !important;
}
.dynamic-select .dynamic-select-header,
.dynamic-select .dynamic-select-option {
  height: calc(1.5em + 1.034rem + calc(var(--bs-border-width) * 2)) !important;
  padding: 0.517rem 2.85rem 0.517rem 0.95rem !important;
  font-size: 0.812rem !important;
  color: var(--bs-body-color) !important;
}

.modal-content {
  border: none;
}

.modal-header {
  background-color: #25282d;
}
.modal-header .modal-title {
  color: #ffffff;
  font-size: 15px;
}
.modal-header .btn-close {
  font-size: 20px;
}

body {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.page-wrapper .page-content {
  width: 100%;
  margin-right: var(--bs-startbar-width);
  position: relative;
  min-height: calc(100vh - var(--bs-topbar-height));
  padding: 0 0.75rem 68px 0.75rem;
  margin-top: var(--bs-topbar-height);
}
.page-wrapper .page-content .page-title-box {
  padding: 1rem 0;
}
.page-wrapper .page-content .page-title-box .page-title {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
}
.page-wrapper .page-content .page-title-box .breadcrumb .breadcrumb-item a {
  color: #7a82b1;
  font-weight: 400;
  font-size: 13px;
}

@media (min-width: 680px) {
  .page-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}
.shape {
  position: absolute;
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 0;
}
.shape > svg {
  -webkit-transform: scale(2);
          transform: scale(2);
  width: 100%;
  height: auto;
  -webkit-transform-origin: top center;
          transform-origin: top center;
}

.ex-page-content h1 {
  font-size: 98px;
  font-weight: 700;
  text-shadow: rgba(137, 151, 189, 0.2) 1px 1px, rgba(137, 151, 189, 0.2) 2px 2px, rgba(137, 151, 189, 0.2) 3px 3px;
}

.img-group .user-avatar:hover {
  z-index: 2;
}

.task-accordion.accordion-item:not(:first-of-type) {
  border-top: 1px;
}

.color-bg {
  /*background-image: url("../images/extra/color-bg-2.jpg");*/
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
}

.img-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0 20%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 180px;
}

.social {
  border: 1px solid #a8b5d1;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.social i {
  color: #a8b5d1;
}
.social.twitter:hover {
  border-color: #1da1f2;
  background-color: #1da1f2;
}
.social.twitter:hover i {
  color: #ffffff;
}
.social.instagram:hover {
  border-color: #f09433;
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}
.social.instagram:hover i {
  color: #ffffff;
}
.social.facebook:hover {
  border-color: #1877f2;
  background-color: #1877f2;
}
.social.facebook:hover i {
  color: #ffffff;
}

.list-arrow {
  position: relative;
}
.list-arrow::before {
  content: "\\f178";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #3167f3;
  position: absolute;
  left: -22px;
}

.bg-welcome-img {
  /*background-image: url("../images/extra/welcome.jpg");*/
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-globe-img {
  /*background-image: url("../images/extra/globe.png");*/
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}

.bg-corner-img {
  /*background-image: url("../images/extra/corner.png");*/
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}

.progress {
  background-color: var(--bs-border-color);
}

/* Progressbar Vertical */
.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 8px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.progress-vertical .progress-bar {
  width: 100%;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 8px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
}

.progress-vertical.progress-sm,
.progress-vertical-bottom.progress-sm {
  width: 5px !important;
}
.progress-vertical.progress-sm .progress-bar,
.progress-vertical-bottom.progress-sm .progress-bar {
  font-size: 8px;
  line-height: 5px;
}
.progress-vertical.progress-md,
.progress-vertical-bottom.progress-md {
  width: 15px !important;
}
.progress-vertical.progress-md .progress-bar,
.progress-vertical-bottom.progress-md .progress-bar {
  font-size: 10.8px;
  line-height: 14.4px;
}
.progress-vertical.progress-lg,
.progress-vertical-bottom.progress-lg {
  width: 20px !important;
}
.progress-vertical.progress-lg .progress-bar,
.progress-vertical-bottom.progress-lg .progress-bar {
  font-size: 12px;
  line-height: 20px;
}

.progress-icon-spin {
  font-size: 36px;
}

:root {
  --bs-topbar-height: 75px;
  --bs-topbar-bg: #f9fbfd;
  --bs-topbar-b-border-color: #e3ebf6;
  --bs-topbar-nav-icon-bg: #fff;
  --bs-topbar-nav-icon-color: #424d65;
  --bs-startbar-width: 270px;
  --bs-startbar-collapsed-width: 70px;
  --bs-startbar-bg: #fff;
  --bs-startbar-e-border-color: #e3ebf6;
  --bs-menu-icon-color: #96a0b5;
  --bs-menu-link-color: #061237;
  --bs-menu-link-active-bg-color: #f9fbfd;
  --bs-nav-link-disc-color: #8997bd;
  --bs-menu-label-color: #a0a5b3;
  --bs-label-color: #656d9a;
  --bs-text-muted: var(--bs-secondary-color);
  --bs-box-shadow-sm: 0 2px 2px rgba(61, 71, 81, 0.05);
  --bs-card-bg: var(--bs-secondary-bg);
  --bs-theme-white-color: #ffffff;
  --bs-border-secondary: #95a0c5;
  --bs-table-head-bg: #f4f6f9;
}

html[data-bs-theme=dark] {
  --bs-light: #303231;
  --bs-light-rgb: 48, 50, 49;
  --bs-dark: #f4f6f9;
  --bs-dark-rgb: 244, 246, 249;
  --bs-label-color: #9797a5;
  --bs-theme-white-color: #2e2e31;
  --bs-body-color: #d9e1ec;
  --bs-text-muted: #aab0b9;
  --bs-box-shadow-sm: 0 2px 2px rgba(61, 71, 81, 0.05);
  --bs-card-bg: #151821;
  --bs-topbar-bg: #141824;
  --bs-topbar-b-border-color: #333547;
  --bs-topbar-nav-icon-bg: #222735;
  --bs-topbar-nav-icon-color: #a1a8bd;
  --bs-secondary: #c3c3c3;
  --bs-secondary-rgb: 195, 195, 195;
  --bs-border-secondary: #333645;
  --bs-table-head-bg: #222735;
  --bs-startbar-bg: #141824;
  --bs-startbar-e-border-color: #333547;
  --bs-menu-icon-color: #5e748b;
  --bs-menu-link-color: #a1a8bd;
  --bs-menu-link-active-bg-color: rgba(249, 251, 253, 0.04);
  --bs-menu-link-hover-color: #ffffff;
  --bs-nav-link-disc-color: #8997bd;
  --bs-menu-label-color: #a0a5b3;
}

html[data-startbar=dark] {
  --bs-startbar-bg: #141824;
  --bs-startbar-e-border-color: #333547;
  --bs-menu-icon-color: #5e748b;
  --bs-menu-link-color: #a1a8bd;
  --bs-menu-link-active-bg-color: rgba(249, 251, 253, 0.04);
  --bs-menu-link-hover-color: #ffffff;
  --bs-nav-link-disc-color: #8997bd;
  --bs-menu-label-color: #a0a5b3;
  --bs-dark: #f4f6f9;
  --bs-box-shadow-sm: 0 2px 2px rgba(61, 71, 81, 0.05);
}

.spinner-border.spinner-border-custom-1 {
  border: 5px double currentColor;
  border-right-color: transparent;
}
.spinner-border.spinner-border-custom-2 {
  border: 5px dotted currentColor;
  border-right-color: transparent;
}
.spinner-border.spinner-border-custom-3 {
  border: 5px groove currentColor;
  border-right-color: transparent;
}
.spinner-border.spinner-border-custom-4 {
  border: 5px dashed currentColor;
  border-right-color: transparent;
}
.spinner-border.spinner-border-custom-5 {
  border: 5px outset currentColor;
  border-right-color: transparent;
}

.table th {
  font-weight: 500;
  vertical-align: middle;
}
.table td {
  font-weight: 400;
  vertical-align: middle;
}
.table.border-dashed th {
  font-weight: 500;
  border-top: 1px dashed var(--bs-border-color);
}
.table.border-dashed td {
  border-top: 1px dashed var(--bs-border-color);
}
.table.border-dashed thead th {
  border-bottom: 1px dashed var(--bs-border-color);
}
.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-bottom: none;
}

.table thead th {
  border-bottom: none;
}
.table thead th:last-child {
  border-radius: 8px 0 0 8px;
}
.table thead th:first-child {
  border-radius: 0 8px 8px 0;
}
.table tbody tr:last-child td {
  border-bottom: none;
}

.table th,
.table td {
  vertical-align: middle;
}

.table tbody,
.table td,
.table tfoot,
.table th,
.table thead,
.table tr {
  border-style: dashed;
}

.datatable-table > thead {
  background-color: var(--bs-light) !important;
}
.datatable-table > thead > tr > th {
  color: var(--bs-body-color);
  font-weight: 500;
  background-color: var(--bs-table-head-bg);
}

.dataTable-top,
.datatable-top {
  padding-top: 0;
}

.dataTable-bottom,
.datatable-bottom {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0;
}

.dataTable-table > tfoot > tr > td,
.dataTable-table > tfoot > tr > th,
.dataTable-table > thead > tr > td,
.dataTable-table > thead > tr > th,
.dataTable-table > tbody > tr > td,
.dataTable-table > tbody > tr > th,
.datatable-table > tfoot > tr > td,
.datatable-table > tfoot > tr > th,
.datatable-table > thead > tr > td,
.datatable-table > thead > tr > th,
.datatable-table > tbody > tr > td,
.datatable-table > tbody > tr > th {
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
}
.dataTable-table > tfoot > tr > th,
.dataTable-table > thead > tr > th,
.dataTable-table > tbody > tr > th,
.datatable-table > tfoot > tr > th,
.datatable-table > thead > tr > th,
.datatable-table > tbody > tr > th {
  border-bottom: none;
}

.dataTable-sorter::before,
.datatable-sorter::before {
  border-top: 4px solid var(--bs-border-color);
  opacity: 1;
  left: 4px;
  right: auto;
}

.dataTable-sorter::after,
.datatable-sorter::after {
  border-bottom: 4px solid var(--bs-border-color);
  opacity: 1;
  left: 4px;
  right: auto;
}

.dataTable-sorter::before {
  bottom: 0;
}

.datatable-editor-action .mdi {
  margin-right: 5px;
  color: #95a0c5;
}

.dataTable-selector,
.datatable-selector {
  background-color: var(--bs-card-bg);
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
  border-radius: 4px;
  /*padding-left: 10px;*/
}
.dataTable-selector:focus-visible,
.datatable-selector:focus-visible {
  outline: none;
}

.datatable-editor-input,
.dataTable-input,
.datatable-input {
  background-color: var(--bs-card-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
}
.datatable-editor-input:focus,
.dataTable-input:focus,
.datatable-input:focus {
  border-color: #3167f3;
}
.datatable-editor-input:focus-visible,
.dataTable-input:focus-visible,
.datatable-input:focus-visible {
  outline: none;
}

.datatable-wrapper.no-footer .datatable-container {
  border-bottom: 1px solid var(--bs-border-color);
}

.datatable-pagination a,
.datatable-pagination button {
  margin-left: 0;
}
.datatable-pagination .datatable-active a,
.datatable-pagination .datatable-active button,
.datatable-pagination .datatable-active a:focus,
.datatable-pagination .datatable-active a:hover,
.datatable-pagination .datatable-active button:focus,
.datatable-pagination .datatable-active button:hover {
  color: #ffffff;
  background-color: #3167f3;
  border-color: #3167f3;
}
.datatable-pagination a:hover,
.datatable-pagination button:hover {
  color: var(--bs-link-hover-color);
  background-color: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
}

.datatable-pagination-list-item .datatable-pagination-list-item-link {
  position: relative;
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 0.812rem;
  color: var(--bs-body-color);
  background-color: var(--bs-card-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
}

.datatable-pagination-list-item:first-child .datatable-pagination-list-item-link {
  border-top-right-radius: var(--bs-border-radius);
  border-bottom-right-radius: var(--bs-border-radius);
}

.datatable-pagination-list-item:last-child .datatable-pagination-list-item-link {
  border-top-left-radius: var(--bs-border-radius);
  border-bottom-left-radius: var(--bs-border-radius);
}

.datatable-table th button,
.datatable-pagination-list button {
  color: var(--bs-body-color);
  text-align: start;
}

.checkbox-all thead tr th:first-child button::after, .checkbox-all thead tr th:first-child button::before, .checkbox-all thead tr th:last-child button::after, .checkbox-all thead tr th:last-child button::before {
  display: none;
}

.dataTable-pagination a {
  position: relative;
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 0.812rem;
  color: var(--bs-body-color);
  background-color: var(--bs-card-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  margin: 0;
}
.dataTable-pagination a:hover {
  color: var(--bs-link-hover-color);
  background-color: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
}
.dataTable-pagination .active a,
.dataTable-pagination .active a:focus,
.dataTable-pagination .active a:hover {
  color: #ffffff;
  background-color: #3167f3;
  border-color: #3167f3;
}
.dataTable-pagination li:first-child a {
  border-top-left-radius: var(--bs-border-radius);
  border-bottom-left-radius: var(--bs-border-radius);
}
.dataTable-pagination li:last-child a {
  border-top-right-radius: var(--bs-border-radius);
  border-bottom-right-radius: var(--bs-border-radius);
}

.dataTable-wrapper.no-footer .dataTable-container {
  border-bottom: 1px solid var(--bs-border-color);
}

.datatable-editor-menu {
  background-color: var(--bs-card-bg);
}
.datatable-editor-menu a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.datatable-editor-menu a:hover {
  color: var(--bs-link-hover-color);
  background-color: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
}

.datatable-editor-separator {
  border-bottom: 1px solid var(--bs-border-color);
  margin: 0;
}

html[data-bs-theme=dark] .datatable-container thead,
html[data-bs-theme=dark] .table-light {
  --bs-table-color: #ffffff;
  --bs-table-bg: #23252d;
  --bs-table-border-color: #40424f;
  --bs-table-striped-bg: #363845;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #40424f;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #3b3d4a;
  --bs-table-hover-color: #ffffff;
}

.custom-tooltip {
  --bs-tooltip-bg: var(--bs-purple);
  --bs-tooltip-color: var(--bs-white);
}

.custom-popover {
  --bs-popover-max-width: 200px;
  --bs-popover-border-color: var(--bs-purple);
  --bs-popover-header-bg: var(--bs-purple);
  --bs-popover-header-color: var(--bs-white);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 0.5rem;
}

.nav-tabs-custom .nav.nav-tabs {
  border-bottom: none;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.nav-tabs-custom .nav.nav-tabs .nav-item {
  border: 2px solid rgba(168, 181, 209, 0.2);
  border-radius: 4px;
  margin-right: 5px;
}
.nav-tabs-custom .nav.nav-tabs .nav-link {
  border-radius: 3px;
  padding: 10px 14px;
}
.nav-tabs-custom .nav.nav-tabs .nav-link.active {
  background-color: rgba(49, 103, 243, 0.08);
  border-color: #3167f3;
  color: #3167f3;
}
.nav-tabs-custom .nav.nav-tabs .nav-link.active i {
  color: #3167f3;
}
.nav-tabs-custom .nav.nav-tabs .nav-link i {
  font-size: 24px;
  vertical-align: middle;
  color: #a8b5d1;
}

.tooltip-primary {
  --bs-tooltip-bg: var(--bs-primary);
}

.tooltip-secondary {
  --bs-tooltip-bg: var(--bs-secondary);
}

.tooltip-success {
  --bs-tooltip-bg: var(--bs-success);
}

.tooltip-info {
  --bs-tooltip-bg: var(--bs-info);
}

.tooltip-warning {
  --bs-tooltip-bg: var(--bs-warning);
}

.tooltip-danger {
  --bs-tooltip-bg: var(--bs-danger);
}

.tooltip-pink {
  --bs-tooltip-bg: var(--bs-pink);
}

.tooltip-purple {
  --bs-tooltip-bg: var(--bs-purple);
}

.tooltip-blue {
  --bs-tooltip-bg: var(--bs-blue);
}

.tooltip-light {
  --bs-tooltip-bg: var(--bs-light);
}

.tooltip-dark {
  --bs-tooltip-bg: var(--bs-dark);
}

.nav-tabs.nav-tabs-custom {
  border-bottom: 1px solid var(--bs-border-color);
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border-color: transparent;
  border-bottom: 1px solid #3167f3 !important;
}
.nav-tabs .nav-link:hover {
  border-color: transparent;
}

.fs-9 {
  font-size: 9px;
}

.fs-10 {
  font-size: 10px;
}

.fs-11 {
  font-size: 11px;
}

.fs-12 {
  font-size: 12px;
}

.fs-13 {
  font-size: 13px;
}

.fs-14 {
  font-size: 14px;
}

.fs-15 {
  font-size: 15px;
}

.fs-16 {
  font-size: 16px;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-20 {
  font-size: 20px;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-24 {
  font-size: 24px;
}

.fs-26 {
  font-size: 26px;
}

.fs-28 {
  font-size: 28px;
}

.fs-30 {
  font-size: 30px;
}

.h-80 {
  height: 300px;
}

.mt-n6 {
  margin-top: -100px;
}

.mt-n52 {
  margin-top: -52px;
}

.ms-45 {
  margin-left: 45px;
}

.trans-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.border-dashed {
  border: 1px dashed;
}

.border-theme-color {
  border-color: var(--bs-border-color);
}

.border-dashed-bottom {
  border-bottom: 1px dashed var(--bs-border-color);
}

.border-dashed-top {
  border-top: 1px dashed var(--bs-border-color);
}

.border-body-color {
  border-color: #f9fbfd;
}

.border-card-bg {
  border-color: var(--bs-secondary-bg) !important;
}

.border-secondary {
  border-color: var(--bs-border-secondary) !important;
}

.bg-blue-subtle {
  background-color: var(--bs-blue-bg-subtle);
}

.bg-pink-subtle {
  background-color: var(--bs-pink-bg-subtle);
}

.bg-purple-subtle {
  background-color: var(--bs-purple-bg-subtle);
}

.cursor-pointer {
  cursor: pointer;
}

.thumb-xs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 20px !important;
  width: 20px !important;
  font-size: 10px;
  font-weight: 700;
}

.thumb-sm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 24px !important;
  width: 24px !important;
  font-size: 12px;
  font-weight: 700;
}

.thumb-md {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 36px;
  width: 36px;
  font-size: 14px;
  font-weight: 700;
}

.thumb-lg {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 48px;
  width: 48px;
  font-size: 18px;
  font-weight: 700;
}

.thumb-xl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 60px;
  width: 60px;
  font-size: 24px;
  font-weight: 700;
}

.thumb-xxl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 80px;
  width: 80px;
  font-size: 32px;
  font-weight: 700;
}

.card-bg {
  background-color: var(--bs-secondary-bg);
}

.text-card-bg {
  color: var(--bs-secondary-bg);
}

.flex-basis-0 {
  -ms-flex-preferred-size: 0;
      flex-basis: 0;
}

hr.hr-dashed {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px dashed var(--bs-border-color);
  height: 0;
  overflow: visible;
  opacity: 1;
}

[class*=" iconoir-"]::before,
[class^=iconoir-]::before {
  stroke-width: 8px;
}

.icon-demo-content {
  text-align: center;
}
.icon-demo-content i {
  display: block;
  font-size: 30px;
  margin: 0 auto 5px;
  color: #a8b5d1;
}
.icon-demo-content svg {
  display: block;
  font-size: 30px;
  margin: 0 auto 5px;
  color: #95a0c5;
}
.icon-demo-content .col-sm-6 {
  margin-bottom: 40px;
}
.icon-demo-content .col-sm-6:hover i {
  color: #3167f3;
}
.icon-demo-content .col-sm-6:hover path:nth-of-type(1) {
  fill: #3167f3;
}
.icon-demo-content .col-sm-6:hover path:nth-of-type(2) {
  fill: var(--bs-secondary-color);
}

.bg-soft-primary {
  background-color: rgba(49, 103, 243, 0.15);
  color: #3167f3;
}

.bg-soft-secondary {
  background-color: rgba(168, 181, 209, 0.15);
  color: #a8b5d1;
}

.bg-soft-success {
  background-color: rgba(13, 166, 132, 0.15);
  color: #0da684;
}

.bg-soft-info {
  background-color: rgba(65, 203, 216, 0.15);
  color: #41cbd8;
}

.bg-soft-warning {
  background-color: rgba(244, 161, 77, 0.15);
  color: #f4a14d;
}

.bg-soft-danger {
  background-color: rgba(239, 52, 99, 0.15);
  color: #ef3463;
}

.bg-soft-pink {
  background-color: rgba(253, 60, 151, 0.15);
  color: #fd3c97;
}

.bg-soft-purple {
  background-color: rgba(91, 88, 230, 0.15);
  color: #5b58e6;
}

.bg-soft-blue {
  background-color: rgba(49, 103, 243, 0.15);
  color: #3167f3;
}

.bg-soft-light {
  background-color: rgba(244, 246, 249, 0.15);
  color: #f4f6f9;
}

.bg-soft-dark {
  background-color: rgba(37, 40, 45, 0.15);
  color: #25282d;
}

.startbar {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: var(--bs-startbar-width);
  background-color: var(--bs-startbar-bg);
  border-right: 1px solid var(--bs-startbar-e-border-color);
  -webkit-transition: 0.3s;
  transition: 0.3s;
  z-index: 1005;
}
.startbar .brand {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: sticky;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  text-align: center;
  padding: 0 20px;
  width: 100%;
  height: var(--bs-topbar-height);
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.startbar .brand .logo-sm {
  height: 28px;
  display: none;
}
.startbar .brand .logo-lg {
  -webkit-transition: 0.3s;
  transition: 0.3s;
  margin-left: 4px;
  height: 28px;
}
.startbar .startbar-menu {
  padding-bottom: var(--bs-topbar-height);
  height: 100vh;
}
.startbar .startbar-menu .startbar-collapse {
  padding: 0 16px 16px;
  height: calc(100vh - 75px);
  overflow-y: auto;
}
.startbar .startbar-menu .navbar-nav .menu-label {
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--bs-menu-label-color);
  padding: 14px 8px 14px 20px;
  text-align: start;
  letter-spacing: 1px;
}
.startbar .startbar-menu .navbar-nav .menu-label small {
  display: none;
}
.startbar .startbar-menu .navbar-nav .nav-item.active {
  border-radius: 0.4rem;
}
.startbar .startbar-menu .navbar-nav .nav-item.active .nav-link.active {
  color: #3167f3;
  background-color: var(--bs-menu-link-active-bg-color);
}
.startbar .startbar-menu .navbar-nav .nav-item.active .nav-link.active .menu-icon {
  color: #3167f3;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link {
  position: relative;
  color: var(--bs-menu-link-color);
  font-size: 13px;
  font-weight: 500;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 10px;
  padding: 10px 16px;
  line-height: 20px;
  margin-bottom: 3px;
  border: 1px solid transparent;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link:hover, .startbar .startbar-menu .navbar-nav .nav-item .nav-link.active {
  color: var(--bs-menu-link-hover-color);
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link:hover i, .startbar .startbar-menu .navbar-nav .nav-item .nav-link.active i {
  color: var(--bs-menu-link-hover-color);
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  display: block;
  content: "\\f105";
  font-family: "Line Awesome Free";
  font-weight: 900;
  margin-right: auto;
  line-height: 20px;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  transition: transform 0.2s, -webkit-transform 0.2s;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  border-radius: 10px;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  color: #3167f3;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true] i,
.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true] span {
  color: #3167f3;
  font-weight: 600;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav {
  position: relative;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav:before {
  content: "";
  position: absolute;
  width: 0.125rem;
  height: calc(100% - 0.25rem);
  background: rgba(137, 151, 189, 0.2);
  top: 0;
  right: 26px;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav .nav-item {
  margin-left: 36px;
}
.startbar .startbar-menu .navbar-nav .nav-item .nav .nav-item .nav-link {
  padding: 6px 16px 6px 16px;
}
.startbar .startbar-menu .menu-icon {
  font-size: 20px;
  /*margin-left: 16px;*/
  color: var(--bs-menu-icon-color);
}

.logo-light {
  display: none;
}

.logo-dark {
  display: inline-block;
}

html[data-startbar=dark] .logo-light,
html[data-bs-theme=dark] .logo-light {
  display: inline-block;
}
html[data-startbar=dark] .logo-dark,
html[data-bs-theme=dark] .logo-dark {
  display: none;
}

@media (min-width: 1200px) {
  body[data-sidebar-size=collapsed] .startbar:not(:hover) {
    width: var(--bs-startbar-collapsed-width);
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand {
    width: var(--bs-startbar-collapsed-width);
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand .logo {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand .logo .logo-lg {
    width: 0;
    margin-left: 0;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand .logo .logo-sm {
    display: inline-block;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .menu-label {
    text-align: center;
    font-weight: 600;
    padding: 0;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .menu-label span {
    display: none;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .menu-label small {
    display: inline-block;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 10px 18px;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link span {
    display: none;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after, body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=true]:after {
    display: none;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link .menu-icon {
    margin-right: 0;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .collapse {
    display: none;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .starbar-user {
    width: calc(var(--bs-startbar-collapsed-width) - 1px);
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .starbar-user img.thumb-lg {
    height: 40px;
    width: 40px;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .starbar-user span {
    display: none !important;
  }
  body[data-sidebar-size=collapsed] .startbar:not(:hover) .update-msg {
    display: none;
  }
  body[data-sidebar-size=collapsed] .page-wrapper .page-content {
    margin-right: var(--bs-startbar-collapsed-width);
  }
}
.page-wrapper .page-content {
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

@media (max-width: 1199.98px) {
  body[data-sidebar-size=collapsed] .startbar {
    margin-right: calc(var(--bs-startbar-width) * -1);
  }
  .page-wrapper .page-content {
    margin-right: 0;
  }
  body[data-sidebar-size=default] .brand {
    width: var(--bs-startbar-width);
  }
  body[data-sidebar-size=default] .brand .logo {
    display: block;
  }
  body[data-sidebar-size=default] .brand .logo .logo-lg {
    width: auto;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .menu-label {
    text-align: start;
    border-color: transparent;
    font-weight: 400;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .menu-label span {
    display: inline-block;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .menu-label small {
    display: none;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link {
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: start;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link span {
    display: inline-block;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after, body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=true]:after {
    display: inline-block;
  }
  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link .menu-icon {
    margin-left: 8px;
  }
  body[data-sidebar-size=default] .page-wrapper .page-content {
    width: 100%;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    margin-right: 0;
  }
}
.update-msg {
  border-radius: 5px;
  padding: 1.5rem 12px;
  margin: 50px 16px 16px;
  position: relative;
  background-color: rgba(49, 103, 243, 0.08);
}
.update-msg h5 {
  color: var(--bs-menu-link-color);
  font-weight: 700;
}
.update-msg .update-icon-box {
  background-color: var(--bs-startbar-bg);
  border: 5px solid rgba(49, 103, 243, 0.08);
  margin-top: -40px;
}
.update-msg a.btn {
  background-color: var(--bs-startbar-bg);
}

.startbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none;
}

.startbar-enable .startbar-overlay {
  display: block;
}

@media (max-width: 1199.98px) {
  [data-sidebar-size=default] .startbar-overlay {
    display: block;
  }
}
[dir=rtl] .startbar .nav-link[data-bs-toggle=collapse]:after {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.label-border {
  margin: 12px 0;
}
.label-border .border_left {
  display: inline;
  position: relative;
}
.label-border .border_left:before {
  content: "";
  display: inline-block;
  border-bottom: 2px solid rgba(49, 103, 243, 0.2);
  width: 20px;
  position: relative;
  top: -7px;
}
.label-border .border_left:after {
  content: "";
  display: inline-block;
  border-bottom: 2px solid rgba(49, 103, 243, 0.5);
  width: 6px;
  position: absolute;
  top: 7px;
  right: 0;
}
.label-border .border_right {
  display: inline;
  position: relative;
}
.label-border .border_right:before {
  content: "";
  display: inline-block;
  border-bottom: 2px solid rgba(49, 103, 243, 0.2);
  width: 20px;
  position: relative;
  top: -1px;
}
.label-border .border_right:after {
  content: "";
  display: inline-block;
  border-bottom: 2px solid rgba(49, 103, 243, 0.5);
  width: 6px;
  position: absolute;
  bottom: 10px;
  left: 0;
}

.topbar {
  height: var(--bs-topbar-height);
  width: calc(100% - var(--bs-startbar-width));
  margin-right: auto;
  position: fixed;
  right: 0;
  top: 0;
  left: 0;
  z-index: 1000;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: none;
          box-shadow: none;
  background-color: var(--bs-topbar-bg);
  padding: 0 0.75rem;
  border-bottom: 1px solid var(--bs-topbar-b-border-color);
}
.topbar .topbar-custom {
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.topbar .topbar-custom:last-child ul li:last-child .nav-icon {
  margin-right: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.topbar .topbar-custom .topbar-item {
  height: var(--bs-topbar-height);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.topbar .topbar-custom .nav-link {
  margin: 0 5px;
}
.topbar .topbar-custom .nav-link.mobile-menu-btn {
  margin-left: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.topbar .topbar-custom .nav-link.nav-icon {
  width: 36px;
  height: 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 50%;
}
.topbar .topbar-custom .nav-link.nav-icon i {
  font-size: 24px;
  color: var(--bs-topbar-nav-icon-color);
}
.topbar .app-search {
  position: relative;
  margin: 0;
}
.topbar .app-search form {
  position: relative;
  z-index: 1;
}
.topbar .app-search form .form-control,
.topbar .app-search form .form-control:focus {
  border: 1px solid var(--bs-topbar-b-border-color);
  font-size: 13px;
  height: 42px;
  background: var(--bs-topbar-nav-icon-bg);
  width: 300px;
  border-radius: 30px;
  padding-left: 48px;
  margin: 0 8px;
}
.topbar .app-search form button {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 16px;
  top: 50%;
  font-size: 22px;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  border: none;
  text-align: center;
  background-color: transparent;
  color: var(--bs-topbar-nav-icon-color);
}
.topbar .app-search form button i {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.topbar .app-search form button:focus {
  outline: none;
}
.topbar .app-search ::-webkit-input-placeholder {
  color: var(--bs-topbar-nav-icon-color);
  font-weight: 400;
}
.topbar .app-search ::-moz-placeholder {
  color: var(--bs-topbar-nav-icon-color);
  font-weight: 400;
}
.topbar .app-search :-ms-input-placeholder {
  color: var(--bs-topbar-nav-icon-color);
  font-weight: 400;
}
.topbar .app-search ::-ms-input-placeholder {
  color: var(--bs-topbar-nav-icon-color);
  font-weight: 400;
}
.topbar .app-search ::placeholder {
  color: var(--bs-topbar-nav-icon-color);
  font-weight: 400;
}
.topbar .app-search input.form-control:-moz-placeholder {
  color: var(--bs-topbar-nav-icon-color);
}
.topbar .app-search input.form-control::-moz-placeholder {
  color: var(--bs-topbar-nav-icon-color);
}
.topbar .app-search input.form-control:-ms-input-placeholder {
  color: var(--bs-topbar-nav-icon-color);
}

html[data-bs-theme=dark] .topbar .topbar-custom .nav-link.nav-icon .light-mode {
  display: none;
}
html[data-bs-theme=dark] .topbar .topbar-custom .nav-link.nav-icon .dark-mode {
  display: inline-block;
}

html[data-bs-theme=light] .topbar .topbar-custom .nav-link.nav-icon .light-mode {
  display: inline-block;
}
html[data-bs-theme=light] .topbar .topbar-custom .nav-link.nav-icon .dark-mode {
  display: none;
}

@media (min-width: 1023.98px) {
  body[data-sidebar-size=collapsed] .topbar {
    width: calc(100% - var(--bs-startbar-collapsed-width));
  }
  .welcome-text {
    display: inline-block;
  }
}
@media (max-width: 1024px) {
  body[data-sidebar-size=collapsed] .topbar,
  body[data-sidebar-size=default] .topbar {
    width: 100%;
  }
  .welcome-text {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .hide-phone {
    display: none !important;
  }
  .topbar .topbar-custom .nav-link {
    margin: 0 4px;
  }
  .topbar .topbar-custom.nav-sticky .nav-link.mobile-menu-btn {
    margin-left: 4px;
  }
  .topbar .topbar-custom.nav-sticky:last-child ul li:last-child .nav-icon {
    margin-right: 4px;
  }
}
@media (max-width: 380px) {
  .topbar .topbar-custom {
    margin: 0;
  }
}
.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 36px;
  text-align: center;
  padding: 16px 0 8px;
  border: 1px solid transparent;
  color: var(--bs-body-color);
}
.dropdown-icon-item img {
  height: 36px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.dropdown-icon-item:hover {
  background-color: #fff;
}

/*
Template Name: Approx - Admin & Dashboard Template
Author: Mannatthemes
Version: 2.2.0
File: footer Css
*/
.footer {
  bottom: 0;
  position: absolute;
  right: 0;
  left: 0;
  background-color: var(--bs-body-bg);
}

.chat-box-left {
  float: left;
  width: 340px;
  height: 710px;
  background-color: var(--bs-secondary-bg);
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
}
.chat-box-left .chat-body-left {
  height: 556px;
}

.chat-box-right {
  width: auto;
  background-color: var(--bs-body-bg);
  display: block;
  border-radius: 8px;
  position: relative;
  height: 710px;
  margin-left: 361px;
  margin-bottom: 20px;
}
.chat-box-right .chat-body {
  padding: 16px;
  height: 540px;
}
.chat-box-right .chat-body .chat-detail {
  max-height: 610px;
}
.chat-box-right .chat-body .chat-detail .chat-box .user-chat p {
  background-color: var(--bs-secondary-bg);
  -webkit-box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);
          box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);
  border-radius: 16px 16px 16px 0;
  padding: 14px;
  margin-bottom: 4px;
  width: 75%;
  max-width: max-content;
}
.chat-box-right .chat-body .chat-detail .chat-box.reverse {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}
.chat-box-right .chat-body .chat-detail .chat-box.reverse .user-chat {
  display: contents;
  width: 100%;
}
.chat-box-right .chat-body .chat-detail .chat-box.reverse .user-chat p {
  background-color: #3167f3;
  color: #ffffff;
  border-radius: 16px 16px 0 16px;
  text-align: end;
}
.chat-box-right .chat-body .chat-detail .chat-box .chat-time {
  font-size: 10px;
}
.chat-box-right .chat-footer {
  background-color: var(--bs-secondary-bg);
  border-radius: 8px;
  padding: 16px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}
.chat-box-right .chat-footer .chat-features a {
  color: #c1cde0;
  font-size: 22px;
  margin-left: 12px;
}
.chat-box-right .chat-footer .chat-features a:hover {
  color: #3167f3;
}
.chat-box-right .chat-footer input.form-control {
  border: none;
}

@media (min-width: 1024px) and (max-width: 1680px) {
  .chat-box-left {
    width: 310px;
    float: left;
  }
  .chat-box-right {
    width: auto;
    margin-left: 330px;
  }
}
@media (min-width: 767px) and (max-width: 1023.98px) {
  .chat-box-left {
    width: 100%;
    float: none;
  }
  .chat-box-right {
    width: 100%;
    margin-left: 0;
  }
}
@media (max-width: 767px) {
  .chat-box-left {
    float: none;
    width: 100%;
  }
  .chat-box-right {
    margin: 0;
    width: 100%;
  }
}
@media (max-width: 660px) {
  .chat-box-left {
    float: none;
    width: 100%;
  }
  .chat-box-right {
    margin: 0;
    width: 100%;
  }
}
@media (max-width: 568px) {
  .chat-box-left {
    float: none;
    width: 100%;
  }
  .chat-box-right {
    margin: 0;
    width: 100%;
  }
}
.kanban-board {
  margin-bottom: 0.75rem;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
  overflow-x: auto;
  padding-bottom: 1rem;
}
.kanban-board .kanban-col {
  -webkit-margin-end: 1.5rem;
          margin-inline-end: 1.5rem;
  position: relative;
  width: 100%;
  min-width: 20rem;
}
.kanban-board .kanban-col:last-child {
  -webkit-margin-end: 0;
          margin-inline-end: 0;
}
.kanban-board .kanban-col .add-btn {
  display: none;
  position: relative;
}
.kanban-board .kanban-col:hover .add-btn {
  display: inline-block;
}

.pricing-content li {
  margin-bottom: 14px;
  font-weight: 500;
  color: #7a82b1;
}
.pricing-content li:before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
  font-size: 9px;
  text-align: center;
  background-color: rgba(49, 103, 243, 0.1);
  color: #3167f3;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 8px;
}

.animate-blink {
  -webkit-animation: a-animate-blink 1s step-start 0s infinite;
  animation: a-animate-blink 1s step-start 0s infinite;
  -webkit-animation-fill-mode: initial;
          animation-fill-mode: initial;
}

@-webkit-keyframes a-animate-blink {
  50% {
    opacity: 0;
  }
}
@keyframes a-animate-blink {
  50% {
    opacity: 0;
  }
}
@media print {
  .page-wrapper .page-content {
    width: 100%;
    margin-top: 0;
  }
}
.starability-basic,
.starability-growRotate,
.starability-grow,
.starability-fade,
.starability-slot,
.starability-checkmark {
  min-height: auto;
}
.starability-basic > input:checked + label,
.starability-basic > input:focus + label,
.starability-growRotate > input:checked + label,
.starability-growRotate > input:focus + label,
.starability-grow > input:checked + label,
.starability-grow > input:focus + label,
.starability-fade > input:checked + label,
.starability-fade > input:focus + label,
.starability-slot > input:checked + label,
.starability-slot > input:focus + label,
.starability-checkmark > input:checked + label,
.starability-checkmark > input:focus + label {
  outline: none;
  text-decoration: none;
}

.ribbon1 {
  position: absolute;
  top: -6.1px;
  right: 10px;
}
.ribbon1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 30px solid transparent;
  border-right: 30px solid transparent;
  border-top: 10px solid;
}
.ribbon1 span {
  display: block;
  padding: 6px 4px 0px;
  border-top-right-radius: 6px;
  width: 60px;
  font-size: 11px;
  font-weight: 500;
}
.ribbon1 span:before, .ribbon1 span:after {
  position: absolute;
  content: "";
}
.ribbon1 span:before {
  height: 6px;
  width: 4px;
  left: -4px;
  top: 0;
}
.ribbon1 span:after {
  height: 6px;
  width: 6px;
  left: -6px;
  top: 0;
  border-radius: 8px 8px 0 0;
}
.ribbon1 span.rib1-primary, .ribbon1 span:before {
  background: #3167f3;
}
.ribbon1 span.rib1-primary:after {
  background: #0c41cc;
}
.ribbon1 span.rib1-secondary, .ribbon1 span:before {
  background: #a8b5d1;
}
.ribbon1 span.rib1-secondary:after {
  background: #768ab7;
}
.ribbon1 span.rib1-success, .ribbon1 span:before {
  background: #0da684;
}
.ribbon1 span.rib1-success:after {
  background: #075f4c;
}
.ribbon1 span.rib1-info, .ribbon1 span:before {
  background: #41cbd8;
}
.ribbon1 span.rib1-info:after {
  background: #239eaa;
}
.ribbon1 span.rib1-warning, .ribbon1 span:before {
  background: #f4a14d;
}
.ribbon1 span.rib1-warning:after {
  background: #e67b0e;
}
.ribbon1 span.rib1-danger, .ribbon1 span:before {
  background: #ef3463;
}
.ribbon1 span.rib1-danger:after {
  background: #c7103e;
}
.ribbon1 span.rib1-pink, .ribbon1 span:before {
  background: #fd3c97;
}
.ribbon1 span.rib1-pink:after {
  background: #ea0270;
}
.ribbon1 span.rib1-purple, .ribbon1 span:before {
  background: #5b58e6;
}
.ribbon1 span.rib1-purple:after {
  background: #231fd2;
}
.ribbon1 span.rib1-blue, .ribbon1 span:before {
  background: #3167f3;
}
.ribbon1 span.rib1-blue:after {
  background: #0c41cc;
}
.ribbon1 span.rib1-light, .ribbon1 span:before {
  background: #f4f6f9;
}
.ribbon1 span.rib1-light:after {
  background: #c3cede;
}
.ribbon1 span.rib1-dark, .ribbon1 span:before {
  background: #25282d;
}
.ribbon1 span.rib1-dark:after {
  background: #020303;
}
.ribbon1.rib1-primary:after {
  border-top-color: #3167f3;
}
.ribbon1.rib1-secondary:after {
  border-top-color: #a8b5d1;
}
.ribbon1.rib1-success:after {
  border-top-color: #0da684;
}
.ribbon1.rib1-info:after {
  border-top-color: #41cbd8;
}
.ribbon1.rib1-warning:after {
  border-top-color: #f4a14d;
}
.ribbon1.rib1-danger:after {
  border-top-color: #ef3463;
}
.ribbon1.rib1-pink:after {
  border-top-color: #fd3c97;
}
.ribbon1.rib1-purple:after {
  border-top-color: #5b58e6;
}
.ribbon1.rib1-blue:after {
  border-top-color: #3167f3;
}
.ribbon1.rib1-light:after {
  border-top-color: #f4f6f9;
}
.ribbon1.rib1-dark:after {
  border-top-color: #25282d;
}

.ribbon2 {
  width: 30px;
  padding: 8px 0;
  position: absolute;
  top: -6px;
  right: 12px;
  text-align: center;
  border-top-left-radius: 3px;
}
.ribbon2:before, .ribbon2:after {
  content: "";
  position: absolute;
}
.ribbon2:before {
  height: 0;
  width: 0;
  right: -5.5px;
  top: 0.1px;
  border-right: 6px solid transparent;
}
.ribbon2:after {
  height: 0;
  width: 0;
  bottom: -18px;
  left: 0;
  border-bottom: 18px solid transparent;
}
.ribbon2.rib2-primary {
  background: #3167f3;
}
.ribbon2.rib2-primary:before {
  border-bottom: 6px solid #0c41cc;
}
.ribbon2.rib2-primary:after {
  border-left: 15px solid #3167f3;
  border-right: 15px solid #3167f3;
}
.ribbon2.rib2-secondary {
  background: #a8b5d1;
}
.ribbon2.rib2-secondary:before {
  border-bottom: 6px solid #768ab7;
}
.ribbon2.rib2-secondary:after {
  border-left: 15px solid #a8b5d1;
  border-right: 15px solid #a8b5d1;
}
.ribbon2.rib2-success {
  background: #0da684;
}
.ribbon2.rib2-success:before {
  border-bottom: 6px solid #075f4c;
}
.ribbon2.rib2-success:after {
  border-left: 15px solid #0da684;
  border-right: 15px solid #0da684;
}
.ribbon2.rib2-info {
  background: #41cbd8;
}
.ribbon2.rib2-info:before {
  border-bottom: 6px solid #239eaa;
}
.ribbon2.rib2-info:after {
  border-left: 15px solid #41cbd8;
  border-right: 15px solid #41cbd8;
}
.ribbon2.rib2-warning {
  background: #f4a14d;
}
.ribbon2.rib2-warning:before {
  border-bottom: 6px solid #e67b0e;
}
.ribbon2.rib2-warning:after {
  border-left: 15px solid #f4a14d;
  border-right: 15px solid #f4a14d;
}
.ribbon2.rib2-danger {
  background: #ef3463;
}
.ribbon2.rib2-danger:before {
  border-bottom: 6px solid #c7103e;
}
.ribbon2.rib2-danger:after {
  border-left: 15px solid #ef3463;
  border-right: 15px solid #ef3463;
}
.ribbon2.rib2-pink {
  background: #fd3c97;
}
.ribbon2.rib2-pink:before {
  border-bottom: 6px solid #ea0270;
}
.ribbon2.rib2-pink:after {
  border-left: 15px solid #fd3c97;
  border-right: 15px solid #fd3c97;
}
.ribbon2.rib2-purple {
  background: #5b58e6;
}
.ribbon2.rib2-purple:before {
  border-bottom: 6px solid #231fd2;
}
.ribbon2.rib2-purple:after {
  border-left: 15px solid #5b58e6;
  border-right: 15px solid #5b58e6;
}
.ribbon2.rib2-blue {
  background: #3167f3;
}
.ribbon2.rib2-blue:before {
  border-bottom: 6px solid #0c41cc;
}
.ribbon2.rib2-blue:after {
  border-left: 15px solid #3167f3;
  border-right: 15px solid #3167f3;
}
.ribbon2.rib2-light {
  background: #f4f6f9;
}
.ribbon2.rib2-light:before {
  border-bottom: 6px solid #c3cede;
}
.ribbon2.rib2-light:after {
  border-left: 15px solid #f4f6f9;
  border-right: 15px solid #f4f6f9;
}
.ribbon2.rib2-dark {
  background: #25282d;
}
.ribbon2.rib2-dark:before {
  border-bottom: 6px solid #020303;
}
.ribbon2.rib2-dark:after {
  border-left: 15px solid #25282d;
  border-right: 15px solid #25282d;
}

.ribbon3 {
  text-align: center;
  width: 70px;
  height: 26px;
  line-height: 26px;
  padding-right: 12px;
  position: absolute;
  right: -8px;
  top: 10px;
  font-size: 11px;
  font-weight: 500;
}
.ribbon3:before, .ribbon3:after {
  content: "";
  position: absolute;
}
.ribbon3:before {
  height: 0;
  width: 0;
  bottom: -8.5px;
  right: 0.1px;
  border-right: 9px solid transparent;
}
.ribbon3:after {
  height: 0;
  width: 0;
  left: -14.5px;
  border-bottom: 13px solid transparent;
  border-top: 13px solid transparent;
}
.ribbon3.rib3-primary {
  background: #3167f3;
}
.ribbon3.rib3-primary:before {
  border-top: 9px solid #0c41cc;
}
.ribbon3.rib3-primary:after {
  border-right: 15px solid #3167f3;
}
.ribbon3.rib3-secondary {
  background: #a8b5d1;
}
.ribbon3.rib3-secondary:before {
  border-top: 9px solid #768ab7;
}
.ribbon3.rib3-secondary:after {
  border-right: 15px solid #a8b5d1;
}
.ribbon3.rib3-success {
  background: #0da684;
}
.ribbon3.rib3-success:before {
  border-top: 9px solid #075f4c;
}
.ribbon3.rib3-success:after {
  border-right: 15px solid #0da684;
}
.ribbon3.rib3-info {
  background: #41cbd8;
}
.ribbon3.rib3-info:before {
  border-top: 9px solid #239eaa;
}
.ribbon3.rib3-info:after {
  border-right: 15px solid #41cbd8;
}
.ribbon3.rib3-warning {
  background: #f4a14d;
}
.ribbon3.rib3-warning:before {
  border-top: 9px solid #e67b0e;
}
.ribbon3.rib3-warning:after {
  border-right: 15px solid #f4a14d;
}
.ribbon3.rib3-danger {
  background: #ef3463;
}
.ribbon3.rib3-danger:before {
  border-top: 9px solid #c7103e;
}
.ribbon3.rib3-danger:after {
  border-right: 15px solid #ef3463;
}
.ribbon3.rib3-pink {
  background: #fd3c97;
}
.ribbon3.rib3-pink:before {
  border-top: 9px solid #ea0270;
}
.ribbon3.rib3-pink:after {
  border-right: 15px solid #fd3c97;
}
.ribbon3.rib3-purple {
  background: #5b58e6;
}
.ribbon3.rib3-purple:before {
  border-top: 9px solid #231fd2;
}
.ribbon3.rib3-purple:after {
  border-right: 15px solid #5b58e6;
}
.ribbon3.rib3-blue {
  background: #3167f3;
}
.ribbon3.rib3-blue:before {
  border-top: 9px solid #0c41cc;
}
.ribbon3.rib3-blue:after {
  border-right: 15px solid #3167f3;
}
.ribbon3.rib3-light {
  background: #f4f6f9;
}
.ribbon3.rib3-light:before {
  border-top: 9px solid #c3cede;
}
.ribbon3.rib3-light:after {
  border-right: 15px solid #f4f6f9;
}
.ribbon3.rib3-dark {
  background: #25282d;
}
.ribbon3.rib3-dark:before {
  border-top: 9px solid #020303;
}
.ribbon3.rib3-dark:after {
  border-right: 15px solid #25282d;
}

.ribbon4 {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: 8px;
  overflow: hidden;
}
.ribbon4:before, .ribbon4:after {
  content: "";
  position: absolute;
}
.ribbon4:before {
  width: 40px;
  height: 8px;
  right: 44px;
  border-radius: 8px 8px 0px 0px;
}
.ribbon4:after {
  width: 8px;
  height: 40px;
  right: 0px;
  top: 44px;
  border-radius: 0px 8px 8px 0px;
}
.ribbon4.rib4-primary:after, .ribbon4.rib4-primary:before {
  background: #0d49e4;
}
.ribbon4.rib4-secondary:after, .ribbon4.rib4-secondary:before {
  background: #8799bf;
}
.ribbon4.rib4-success:after, .ribbon4.rib4-success:before {
  background: #09775e;
}
.ribbon4.rib4-info:after, .ribbon4.rib4-info:before {
  background: #27b2bf;
}
.ribbon4.rib4-warning:after, .ribbon4.rib4-warning:before {
  background: #f1881d;
}
.ribbon4.rib4-danger:after, .ribbon4.rib4-danger:before {
  background: #de1245;
}
.ribbon4.rib4-pink:after, .ribbon4.rib4-pink:before {
  background: #fc0a7c;
}
.ribbon4.rib4-purple:after, .ribbon4.rib4-purple:before {
  background: #2f2cdf;
}
.ribbon4.rib4-blue:after, .ribbon4.rib4-blue:before {
  background: #0d49e4;
}
.ribbon4.rib4-light:after, .ribbon4.rib4-light:before {
  background: #d3dbe7;
}
.ribbon4.rib4-dark:after, .ribbon4.rib4-dark:before {
  background: #0e0f11;
}
.ribbon4 .ribbon4-band {
  width: 170px;
  height: 20px;
  line-height: 20px;
  position: absolute;
  top: 16px;
  right: -50px;
  z-index: 2;
  overflow: hidden;
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
  border: 1px dashed;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
}
.ribbon4 .ribbon4-band.ribbon4-band-primary {
  -webkit-box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #3167f3;
}
.ribbon4 .ribbon4-band.ribbon4-band-secondary {
  -webkit-box-shadow: 0 0 0 3px #a8b5d1, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #a8b5d1, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #a8b5d1;
}
.ribbon4 .ribbon4-band.ribbon4-band-success {
  -webkit-box-shadow: 0 0 0 3px #0da684, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #0da684, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #0da684;
}
.ribbon4 .ribbon4-band.ribbon4-band-info {
  -webkit-box-shadow: 0 0 0 3px #41cbd8, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #41cbd8, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #41cbd8;
}
.ribbon4 .ribbon4-band.ribbon4-band-warning {
  -webkit-box-shadow: 0 0 0 3px #f4a14d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #f4a14d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #f4a14d;
}
.ribbon4 .ribbon4-band.ribbon4-band-danger {
  -webkit-box-shadow: 0 0 0 3px #ef3463, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #ef3463, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #ef3463;
}
.ribbon4 .ribbon4-band.ribbon4-band-pink {
  -webkit-box-shadow: 0 0 0 3px #fd3c97, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #fd3c97, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #fd3c97;
}
.ribbon4 .ribbon4-band.ribbon4-band-purple {
  -webkit-box-shadow: 0 0 0 3px #5b58e6, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #5b58e6, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #5b58e6;
}
.ribbon4 .ribbon4-band.ribbon4-band-blue {
  -webkit-box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #3167f3;
}
.ribbon4 .ribbon4-band.ribbon4-band-light {
  -webkit-box-shadow: 0 0 0 3px #f4f6f9, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #f4f6f9, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #f4f6f9;
}
.ribbon4 .ribbon4-band.ribbon4-band-dark {
  -webkit-box-shadow: 0 0 0 3px #25282d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
          box-shadow: 0 0 0 3px #25282d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);
  background: #25282d;
}

.activity .activity-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 5px 0;
  position: relative;
  min-height: 60px;
}
.activity .activity-info::before {
  content: "";
  position: absolute;
  bottom: 0;
  top: 42px;
  left: 18px;
  border-left: 2px dotted var(--bs-border-color);
}
.activity .activity-info .icon-info-activity i {
  width: 36px;
  height: 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border-radius: 50%;
  color: var(--bs-secondary-color);
  -webkit-box-shadow: 0px 0px 1px 0.25px;
          box-shadow: 0px 0px 1px 0.25px;
  font-size: 18px;
  border: 1px solid var(--bs-border-color);
  margin-left: 2px;
}
.activity .activity-info .activity-info-text {
  margin-left: 16px;
  width: 100%;
}
.activity .activity-info .activity-info-text a,
.activity .activity-info .activity-info-text span {
  color: #7a82b1;
}

.icon-item {
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 2.5rem;
  width: 2.5rem;
}

.icon-item.icon-item-md {
  height: 2.5rem;
  width: 2.5rem;
}

.tracking-item {
  border-left: 1px solid var(--bs-border-color);
  position: relative;
  padding: 24px 30px;
  margin-left: 150px;
}
.tracking-item .tracking-date {
  position: absolute;
  left: -160px;
  width: 120px;
  text-align: right;
  font-weight: 500;
  font-size: 12px;
}
.tracking-item .tracking-icon {
  line-height: 18px;
  position: absolute;
  left: -9px;
  width: 18px;
  height: 18px;
  text-align: center;
  border-radius: 50%;
  background-color: var(--bs-secondary-bg);
}
.tracking-item .tracking-icon.icon-inner {
  color: #a8b5d1;
  font-size: 4px;
  -webkit-box-shadow: 0px 0px 1px 1px #c1cde0;
          box-shadow: 0px 0px 1px 1px #c1cde0;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 13px;
  margin: 5px;
  padding: 7px 5px;
  text-align: center;
  background-color: rgba(49, 103, 243, 0.18);
  color: #3167f3;
}

.fc .fc-header-toolbar.fc-toolbar .fc-toolbar-chunk h2 {
  font-size: 16px;
  text-transform: uppercase;
  color: #3167f3;
}
.fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}
.fc .fc-col-header-cell-cushion {
  padding: 10px 0;
  color: var(--bs-body-color);
}
.fc .fc-button {
  font-size: 0.812rem;
}
.fc .fc-button-primary {
  background: transparent;
  border: 1px solid var(--bs-border-color);
  color: #95a0c5;
  text-transform: capitalize;
  text-shadow: none;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.fc .fc-button-primary:hover {
  background: #3167f3;
  color: #ffffff;
  border-color: var(--bs-border-color);
}
.fc .fc-button-primary.active, .fc .fc-button-primary:focus, .fc .fc-button-primary:active {
  text-shadow: none;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.fc .fc-button-primary:disabled {
  background: rgba(49, 103, 243, 0.1);
  color: #3167f3;
  border-color: var(--bs-border-color);
  opacity: 1;
}
.fc .fc-button-primary:not(:disabled):active, .fc .fc-button-primary:not(:disabled).fc-button-active {
  background: #3167f3;
  color: #ffffff;
  border-color: var(--bs-border-color);
}
.fc .fc-button-primary:not(:disabled):active:focus, .fc .fc-button-primary:not(:disabled).fc-button-active:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.fc .fc-daygrid-day-number {
  color: var(--bs-body-color);
  font-weight: 500;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: transparent;
  padding: 4px;
  border-radius: 24px;
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-frame {
  background-color: rgba(49, 103, 243, 0.18);
  border-radius: 8px;
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-frame .fc-daygrid-day-number {
  font-size: 16px;
  font-weight: 800;
}

.fc-license-message {
  display: none;
}

.fc-theme-standard .fc-scrollgrid,
.fc-theme-standard td,
.fc-theme-standard th {
  border: 1px solid var(--bs-border-color);
}

.fc-day-other {
  background-image: linear-gradient(-45deg, var(--bs-secondary-bg) 25%, transparent 25%, transparent 50%, var(--bs-secondary-bg) 50%, rgba(122, 130, 177, 0.2) 75%, transparent 75%, transparent);
  background-size: 10px 10px;
}

.fc-h-event .fc-event-main {
  color: #3167f3;
  font-weight: 500;
}

.fc-daygrid-dot-event .fc-event-title {
  font-weight: 500;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-start, .fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start,
.fc-direction-rtl .fc-daygrid-event.fc-event-end {
  background-color: var(--bs-card-bg);
  -webkit-box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);
          box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);
  color: #3167f3;
  border-radius: 4px;
}

[data-simplebar] {
  position: relative;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -ms-flex-line-pack: start;
      align-content: flex-start;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  -webkit-box-sizing: inherit !important;
          box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  -webkit-box-sizing: border-box !important;
          box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  -webkit-box-sizing: inherit !important;
          box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  -webkit-box-flex: inherit;
      -ms-flex-positive: inherit;
          flex-grow: inherit;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -ms-flex-preferred-size: 0;
      flex-basis: 0;
}

.simplebar-height-auto-observer {
  -webkit-box-sizing: inherit;
          box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  -moz-user-select: none;
   -ms-user-select: none;
       user-select: none;
  -webkit-user-select: none;
}
[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  min-height: 10px;
}
.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: rgba(168, 181, 209, 0.5);
  border-radius: 7px;
  left: 2px;
  right: 2px;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  -webkit-transition: opacity 0s linear;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 10px;
}
.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}
.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}
.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}
.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.apexcharts-gridlines-horizontal,
.apexcharts-gridlines-vertical,
.apexcharts-grid,
.apexcharts-gridline,
.apexcharts-xaxis-tick,
.apexcharts-xaxis line,
.apexcharts-gridline line {
  pointer-events: none;
  stroke: var(--bs-border-color);
}

.apexcharts-xaxis line {
  display: none;
}

.apexcharts-grid-borders line,
.apexcharts-radar-series line,
.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,
.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,
.apexcharts-radar-series path,
.apexcharts-radar-series polygon {
  pointer-events: none;
  stroke: var(--bs-border-color);
}

.apexcharts text, .apexcharts-data-labels text {
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-legend-text {
  color: var(--bs-heading-color) !important;
  opacity: 0.8;
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-pie-label {
  fill: #ffffff !important;
}

.apexcharts-xaxis text,
.apexcharts-yaxis text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: var(--bs-heading-color);
  opacity: 0.8;
}

.apexcharts-datalabels text,
.apexcharts-data-labels {
  font-family: var(--bs-font-sans-serif) !important;
  fill: var(--bs-heading-color);
}

.apexcharts-yaxis-annotation-label {
  color: var(--bs-heading-color);
  opacity: 0.8;
}

.apexcharts-point-annotations text,
.apexcharts-xaxis-annotations text,
.apexcharts-yaxis-annotations text {
  fill: #ffffff;
}

.tick text {
  font-family: var(--bs-font-sans-serif) !important;
  font-size: 0.75rem;
}

.extended-x-line,
.extended-y-line,
.horizontal-grid-line,
.vertical-grid-line {
  stroke: #d9e1ec;
}

.bar-chart .percentage-label,
.donut-text,
.legend-entry-name,
.legend-entry-value,
.tick text {
  fill: var(--bs-heading-color);
  opacity: 0.8;
}

.apex-charts {
  min-height: 10px;
}

.apexcharts-tooltip-title {
  font-family: var(--bs-font-sans-serif) !important;
  background: var(--bs-body-bg) !important;
  color: var(--bs-body-color);
  border-color: #f4f6f9;
}

.apexcharts-tooltip-text {
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-tooltip {
  font-family: var(--bs-font-sans-serif) !important;
  background: var(--bs-body-bg) !important;
  border-color: var(--bs-border-color) !important;
  white-space: normal;
}

.apexcharts-xaxistooltip {
  background-color: var(--bs-body-bg);
  border-color: var(--bs-body-bg);
  color: #25282d;
}

.apexcharts-xaxistooltip-top:before,
.apexcharts-xaxistooltip-top:after {
  border-top-color: var(--bs-body-bg);
}

.apexcharts-xaxistooltip-bottom:before,
.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: var(--bs-body-bg);
}

.apexcharts-xaxistooltip:before,
.apexcharts-xaxistooltip:after {
  border-color: var(--bs-body-bg);
}

.apexcharts-title-text,
.apexcharts-datalabel-label {
  color: var(--bs-heading-color);
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-datalabel-value {
  color: #f4f6f9;
}

.apexcharts-legend-marker {
  margin-right: 5px;
  vertical-align: middle;
  height: 5px;
}

.apexcharts-yaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,
.apexcharts-yaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-xaxis-label,
.apexcharts-yaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,
.apexcharts-yaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-xaxis-label,
.apexcharts-xaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,
.apexcharts-xaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-xaxis-label,
.apexcharts-xaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,
.apexcharts-xaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-xaxis-label {
  font-weight: 500;
}

.apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-value, .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-label {
  font-family: var(--bs-font-sans-serif) !important;
  fill: var(--bs-heading-color);
  opacity: 0.8;
  color: var(--bs-heading-color);
  opacity: 0.8;
}

.apexcharts-grid-row {
  background-color: rgba(168, 181, 209, 0.2);
}

/*clock*/
.superpose {
  color: #eaeff5;
  height: 350px;
  width: 100%;
}
.superpose .superclock {
  position: relative;
  width: 300px;
  margin: auto;
}
.superpose .superclock .superclock1 {
  position: absolute;
  left: 10px;
  top: 10px;
}
.superpose .superclock .superclock2 {
  position: absolute;
  left: 60px;
  top: 60px;
}
.superpose .superclock .superclock3 {
  position: absolute;
  left: 110px;
  top: 110px;
}

.drop-shadow {
  -webkit-filter: drop-shadow(0px 8px 4px #f4f6f9);
          filter: drop-shadow(0px 8px 4px #f4f6f9);
}

.tui-chart .tui-chart-chartExportMenu-area {
  z-index: 50;
}

.pill-bar .apexcharts-bar-series.apexcharts-plot-series .apexcharts-series path {
  -webkit-clip-path: inset(0 0 4% 0 round 30px);
          clip-path: inset(0 0 4% 0 round 30px);
}

.gauge text {
  fill: var(--bs-heading-color);
  font-family: var(--bs-font-sans-serif) !important;
}

.tui-chart .tui-chart-chartExportMenu-area .tui-chart-chartExportMenu-button {
  display: none;
}
.tui-chart text {
  fill: var(--bs-body-color);
  font-family: var(--bs-font-sans-serif) !important;
}

.gmaps {
  height: 300px;
  background: #f4f6f9;
  border-radius: 3px;
}

.overlay {
  display: block;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  line-height: 20px;
  background: #3167f3;
  border-radius: 4px;
  padding: 5px 15px;
}

.overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}

.overlay_arrow.above {
  bottom: -9px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #3167f3;
}

.overlay_arrow.below {
  top: -9px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #3167f3;
}

.svgMap-map-wrapper {
  position: relative;
  width: 100%;
  padding-top: 50%;
  overflow: hidden;
  background: #f4f6f9;
}

.jvm-container text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: var(--bs-heading-color) !important;
}

.jvm-tooltip {
  background-color: #3167f3;
  font-family: var(--bs-font-sans-serif) !important;
}

code[class*=language-],
pre[class*=language-] {
  color: #9efeff;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4;
  -ms-hyphens: none;
      hyphens: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  text-shadow: 0 1px #222245;
}

code[class*=language-] ::-moz-selection, code[class*=language-]::-moz-selection, pre[class*=language-] ::-moz-selection, pre[class*=language-]::-moz-selection {
  color: inherit;
  background: #a599e9;
}

code[class*=language-] ::-moz-selection,
code[class*=language-] ::selection,
code[class*=language-]::-moz-selection,
code[class*=language-]::selection,
pre[class*=language-] ::-moz-selection,
pre[class*=language-] ::selection,
pre[class*=language-]::-moz-selection,
pre[class*=language-]::selection {
  color: inherit;
  background: #a599e9;
}

pre[class*=language-] {
  padding: 2em;
  margin: 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #151516;
}

:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
}

.token {
  font-weight: 400;
}

.token.cdata,
.token.comment,
.token.prolog {
  color: #b362ff;
}

.token.atrule,
.token.delimiter,
.token.important,
.token.keyword,
.token.selector {
  color: #ff9d00;
}

.token.attr-name,
.token.operator {
  color: #ffb454;
}

.token.punctuation {
  color: #fff;
}

.token.boolean {
  color: #ff628c;
}

.token.builtin,
.token.doctype,
.token.tag,
.token.tag .punctuation {
  color: #ff9d00;
}

.token.entity,
.token.symbol {
  color: #6897bb;
}

.token.number {
  color: #ff628c;
}

.token.constant,
.token.property,
.token.variable {
  color: #ff628c;
}

.token.char,
.token.string {
  color: #a5ff90;
}

.token.attr-value,
.token.attr-value .punctuation {
  color: #a5c261;
}

.token.attr-value .punctuation:first-child {
  color: #a9b7c6;
}

.token.url {
  color: #287bde;
  text-decoration: underline;
}

.token.function {
  color: #fad000;
}

.token.regex {
  background: #364135;
}

.token.bold {
  font-weight: 700;
}

.token.italic {
  font-style: italic;
}

.token.inserted {
  background: #0f0;
}

.token.deleted {
  background: #ff000d;
}

code.language-css .token.property,
code.language-css .token.property + .token.punctuation {
  color: #a9b7c6;
}

code.language-css .token.id {
  color: #ffc66d;
}

code.language-css .token.selector > .token.attribute,
code.language-css .token.selector > .token.class,
code.language-css .token.selector > .token.pseudo-class,
code.language-css .token.selector > .token.pseudo-element {
  color: #ffc66d;
}

.token.class-name {
  color: #fb94ff;
}

.language-css .token.string,
.style .token.string,
.token.entity,
.token.operator,
.token.url {
  background: 0 0;
}

.line-highlight.line-highlight {
  margin-top: 36px;
  background: -webkit-gradient(linear, left top, right top, from(rgba(179, 98, 255, 0.17)), to(transparent));
  background: linear-gradient(to right, rgba(179, 98, 255, 0.17), transparent);
}

.line-highlight.line-highlight:before,
.line-highlight.line-highlight[data-end]:after {
  content: "";
}

pre.language-html,
pre.language-css,
pre.language-javascript {
  max-height: 220px;
  overflow-y: auto;
}
pre.language-html::-webkit-scrollbar,
pre.language-css::-webkit-scrollbar,
pre.language-javascript::-webkit-scrollbar {
  -webkit-appearance: none;
}
pre.language-html::-webkit-scrollbar:vertical,
pre.language-css::-webkit-scrollbar:vertical,
pre.language-javascript::-webkit-scrollbar:vertical {
  width: 5px;
  margin-right: 5px;
}
pre.language-html::-webkit-scrollbar:horizontal,
pre.language-css::-webkit-scrollbar:horizontal,
pre.language-javascript::-webkit-scrollbar:horizontal {
  height: 10px;
}
pre.language-html::-webkit-scrollbar-thumb,
pre.language-css::-webkit-scrollbar-thumb,
pre.language-javascript::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 10px;
  margin-right: 5px;
  border: none;
  -webkit-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}
pre.language-html::-webkit-scrollbar-track,
pre.language-css::-webkit-scrollbar-track,
pre.language-javascript::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}
pre.language-html::-webkit-scrollbar-corner,
pre.language-css::-webkit-scrollbar-corner,
pre.language-javascript::-webkit-scrollbar-corner {
  background: transparent;
}
pre.language-html:hover::-webkit-scrollbar-thumb,
pre.language-css:hover::-webkit-scrollbar-thumb,
pre.language-javascript:hover::-webkit-scrollbar-thumb {
  background-color: rgba(244, 246, 249, 0.3);
  -webkit-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.swal2-popup {
  background: var(--bs-secondary-bg);
  padding: 1.5rem 1.5rem;
}
.swal2-popup .swal2-title {
  font-size: 20px;
  font-weight: 500;
  color: var(--bs-body-color);
}
.swal2-popup .swal2-content {
  color: #95a0c5;
  font-size: 15px;
}
.swal2-popup.swal2-toast {
  background-color: var(--bs-secondary-bg);
  -webkit-box-shadow: 0 0 0.625em rgba(85, 91, 126, 0.2);
          box-shadow: 0 0 0.625em rgba(85, 91, 126, 0.2);
}
.swal2-popup.swal2-toast .swal2-title {
  line-height: 1.2;
}
.swal2-popup .swal2-styled {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  background-color: transparent;
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  border-radius: 0.25rem;
}
.swal2-popup .swal2-styled:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.swal2-popup .swal2-styled.swal2-confirm {
  font-size: 0.812rem;
  background-color: #0da684;
}
.swal2-popup .swal2-styled.swal2-confirm:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.swal2-popup .swal2-styled.swal2-deny {
  background-color: #3167f3;
  font-size: 0.812rem;
}
.swal2-popup .swal2-styled.swal2-deny:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.swal2-popup .swal2-styled.swal2-cancel {
  font-size: 0.812rem;
  background-color: #ef3463;
}
.swal2-popup .swal2-styled.swal2-cancel:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.swal2-close:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.swal2-footer {
  border-top: 1px solid var(--bs-border-color);
}

.swal2-actions .btn-success,
.swal2-actions .btn-danger {
  border: none;
}
.swal2-actions .btn-success:focus,
.swal2-actions .btn-danger:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}

div:where(.swal2-container) .swal2-html-container {
  color: var(--bs-text-muted);
}
div:where(.swal2-container) input:where(.swal2-input),
div:where(.swal2-container) input:where(.swal2-file),
div:where(.swal2-container) textarea:where(.swal2-textarea) {
  border: 1px solid var(--bs-border-color);
  -webkit-box-shadow: none;
          box-shadow: none;
  color: var(--bs-body-color);
}
div:where(.swal2-container) input:where(.swal2-input):focus,
div:where(.swal2-container) input:where(.swal2-file):focus,
div:where(.swal2-container) textarea:where(.swal2-textarea):focus {
  -webkit-box-shadow: none;
          box-shadow: none;
  border: 1px solid #3167f3;
}

.swal2-icon {
  width: 3em;
  height: 3em;
  margin: 1em auto 1em;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  top: 22px;
  width: 30px;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 9px;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 9px;
}

.swal2-icon .swal2-icon-content {
  font-size: 40px;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line] {
  width: 40px;
  height: 70px;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -23px;
  left: -13px;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -12px;
  left: 36px;
}

.swal2-icon.swal2-success .swal2-success-fix {
  top: 0px;
  left: 12px;
  width: 6px;
  height: 60px;
}

.swal2-icon.swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 28px;
  left: 6px;
  width: 18px;
}

.swal2-icon.swal2-success [class^=swal2-success-line][class\$=long] {
  top: 23px;
  right: 4px;
  width: 30px;
}

@-webkit-keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 24px;
    left: 4px;
    width: 0;
  }
  70% {
    top: 27px;
    left: 0px;
    width: 22px;
  }
  84% {
    top: 30px;
    left: 8px;
    width: 16px;
  }
  100% {
    top: 28px;
    left: 6px;
    width: 18px;
  }
}
@keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 24px;
    left: 4px;
    width: 0;
  }
  70% {
    top: 27px;
    left: 0px;
    width: 22px;
  }
  84% {
    top: 30px;
    left: 8px;
    width: 16px;
  }
  100% {
    top: 28px;
    left: 6px;
    width: 18px;
  }
}
@-webkit-keyframes swal2-animate-success-line-long {
  0% {
    top: 26px;
    right: 10px;
    width: 0;
  }
  65% {
    top: 26px;
    right: 10px;
    width: 0;
  }
  84% {
    top: 22px;
    right: 0;
    width: 34px;
  }
  100% {
    top: 23px;
    right: 4px;
    width: 30px;
  }
}
@keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  65% {
    top: 40px;
    right: 30px;
    width: 0;
  }
  84% {
    top: 22px;
    right: 0;
    width: 34px;
  }
  100% {
    top: 23px;
    right: 4px;
    width: 30px;
  }
}
.noUi-target {
  background: rgba(168, 181, 209, 0.2);
  border-radius: 4px;
  border: 1px solid var(--bs-border-color);
  -webkit-box-shadow: inset 0 1px 1px rgba(168, 181, 209, 0.1), 0 3px 6px -5px rgba(168, 181, 209, 0.2);
          box-shadow: inset 0 1px 1px rgba(168, 181, 209, 0.1), 0 3px 6px -5px rgba(168, 181, 209, 0.2);
}

.noUi-horizontal .noUi-handle {
  width: 16px;
  height: 16px;
  right: -8px;
  top: -6px;
}

.noUi-horizontal {
  height: 7px;
}

/* Handle stripes;
 */
.noUi-handle {
  border: 2px solid var(--bs-border-color);
  border-radius: 50px;
  background: #3167f3;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.noUi-handle:before, .noUi-handle:after {
  height: 4px;
  width: 1px;
  background: #ffffff;
  left: 4px;
  top: 4px;
}

.noUi-handle:after {
  left: 7px;
}

.noUi-connect {
  background: #2c5ddb;
}

.noUi-vertical {
  width: 7px;
}
.noUi-vertical .noUi-handle {
  width: 16px;
  height: 16px;
  right: -5.5px;
  top: -10px;
}
.noUi-vertical .noUi-handle:before, .noUi-vertical .noUi-handle:after {
  width: 5px;
  height: 1px;
  left: 3px;
  top: 7px;
}
.noUi-vertical .noUi-handle:after {
  width: 5px;
  height: 1px;
  left: 3px;
  top: 4px;
}
.noUi-vertical .noUi-origin {
  top: 0;
}

.noUi-marker {
  position: absolute;
  background: rgba(168, 181, 209, 0.2);
}

.noUi-marker-sub {
  background: rgba(168, 181, 209, 0.3);
}

.noUi-marker-large {
  background: rgba(168, 181, 209, 0.3);
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px;
}

.example-val:before {
  content: "Value: ";
}

.noUi-tooltip {
  display: none;
}

.noUi-active .noUi-tooltip {
  display: block;
}

.noUi-tooltip {
  border: 1px solid var(--bs-border-color);
  background: #fafbfc;
  color: #7a82b1;
  padding: 2px 4px;
  font-size: 10px;
}

ul.listree-submenu-items {
  border-left: 1px dashed var(--bs-border-color);
}
ul.listree-submenu-items li a {
  margin-bottom: 12px;
  display: block;
}

.folder-icon div.listree-submenu-heading.collapsed:before {
  content: "\\f07b";
  font-family: "Font Awesome 5 Free";
}

.folder-icon div.listree-submenu-heading.expanded:before {
  content: "\\f07c";
  font-family: "Font Awesome 5 Free";
}

[dir=rtl] ul.listree-submenu-items {
  border-right: none;
}

.listree-submenu-heading {
  padding-bottom: 12px;
}

.dynamic-select {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  position: relative;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
.dynamic-select .dynamic-select-header {
  border: 1px solid #dee2e6;
  padding: 7px 30px 7px 12px;
}
.dynamic-select .dynamic-select-header::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  right: 15px;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 12px;
  width: 12px;
}
.dynamic-select .dynamic-select-header.dynamic-select-header-active {
  border-color: #c1c9d0;
}
.dynamic-select .dynamic-select-header.dynamic-select-header-active::after {
  -webkit-transform: translateY(-50%) rotate(180deg);
          transform: translateY(-50%) rotate(180deg);
}
.dynamic-select .dynamic-select-header.dynamic-select-header-active + .dynamic-select-options {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.dynamic-select .dynamic-select-header .dynamic-select-header-placeholder {
  color: #65727e;
}
.dynamic-select .dynamic-select-options {
  display: none;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -ms-flex-flow: wrap;
      flex-flow: wrap;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;
  margin-top: 5px;
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.dynamic-select .dynamic-select-options::-webkit-scrollbar {
  width: 5px;
}
.dynamic-select .dynamic-select-options::-webkit-scrollbar-track {
  background: #f0f1f3;
}
.dynamic-select .dynamic-select-options::-webkit-scrollbar-thumb {
  background: #cdcfd1;
}
.dynamic-select .dynamic-select-options::-webkit-scrollbar-thumb:hover {
  background: #b2b6b9;
}
.dynamic-select .dynamic-select-options .dynamic-select-option {
  padding: 7px 12px;
}
.dynamic-select .dynamic-select-options .dynamic-select-option:hover, .dynamic-select .dynamic-select-options .dynamic-select-option:active {
  background-color: #f3f4f7;
}
.dynamic-select .dynamic-select-header, .dynamic-select .dynamic-select-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  font-size: 16px;
  color: #212529;
}
.dynamic-select .dynamic-select-header img, .dynamic-select .dynamic-select-option img {
  -o-object-fit: contain;
     object-fit: contain;
  max-height: 100%;
  max-width: 100%;
}
.dynamic-select .dynamic-select-header img.dynamic-size, .dynamic-select .dynamic-select-option img.dynamic-size {
  -o-object-fit: fill;
     object-fit: fill;
  max-height: none;
  max-width: none;
}
.dynamic-select .dynamic-select-header img, .dynamic-select .dynamic-select-header svg, .dynamic-select .dynamic-select-header i, .dynamic-select .dynamic-select-header span, .dynamic-select .dynamic-select-option img, .dynamic-select .dynamic-select-option svg, .dynamic-select .dynamic-select-option i, .dynamic-select .dynamic-select-option span {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin-right: 10px;
}
.dynamic-select .dynamic-select-header.dynamic-select-no-text, .dynamic-select .dynamic-select-option.dynamic-select-no-text {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.dynamic-select .dynamic-select-header.dynamic-select-no-text img, .dynamic-select .dynamic-select-header.dynamic-select-no-text svg, .dynamic-select .dynamic-select-header.dynamic-select-no-text i, .dynamic-select .dynamic-select-header.dynamic-select-no-text span, .dynamic-select .dynamic-select-option.dynamic-select-no-text img, .dynamic-select .dynamic-select-option.dynamic-select-no-text svg, .dynamic-select .dynamic-select-option.dynamic-select-no-text i, .dynamic-select .dynamic-select-option.dynamic-select-no-text span {
  margin-right: 0;
}
.dynamic-select .dynamic-select-header .dynamic-select-option-text, .dynamic-select .dynamic-select-option .dynamic-select-option-text {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
  font-size: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;AAC1D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,yDAAyD;UACjD,iDAAiD;AAC3D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;AAC1D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;AAC1D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;AAC1D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,uDAAuD;UAC/C,+CAA+C;AACzD;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;AAC1D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,uDAAuD;UAC/C,+CAA+C;AACzD;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;AAC1D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,yDAAyD;UACjD,iDAAiD;AAC3D;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,sDAAsD;UAC9C,8CAA8C;AACxD;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;UAChB,gBAAgB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;EAC9B,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wDAAwD;UAChD,gDAAgD;EACxD,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uDAAuD;EACvD,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;UAC3C,2CAA2C;AACrD;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,iDAAiD;AACnD;AACA;EACE,0DAA0D;EAC1D,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,8DAA8D;EAC9D,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,mCAAmC;EACnC,4BAA4B;EAC5B,2DAA2D;EAC3D,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,uEAAuE;EACvE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;AACrC;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;;EAEE,4EAA4E;EAC5E,qDAAqD;EACrD,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,OAAO;AACT;AACA;EACE,2BAA2B;UACnB,mBAAmB;EAC3B,WAAW;EACX,YAAY;EACZ,oCAAoC;UAC5B,4BAA4B;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iHAAiH;AACnH;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAA8C;EAC9C,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mGAAmG;AACrG;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,uDAAuD;EACvD,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mCAAmC;EACnC,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;EACtB,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;EACvC,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;EAC1C,oDAAoD;EACpD,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,oDAAoD;EACpD,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,gCAAgC;EAChC,mCAAmC;EACnC,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,yDAAyD;EACzD,mCAAmC;EACnC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,yDAAyD;EACzD,mCAAmC;EACnC,iCAAiC;EACjC,8BAA8B;EAC9B,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;;;;;;;;;;EAYE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,4CAA4C;EAC5C,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,+CAA+C;EAC/C,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;AACpB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,aAAa;AACf;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;EAChD,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;AACtC;AACA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;AACA;EACE,gDAAgD;EAChD,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;AAC7B;AACA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,wCAAwC;EACxC,0CAA0C;EAC1C,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;AACA;;EAEE,yBAAyB;EACzB,2CAA2C;AAC7C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;UACxB,wBAAwB;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;MACtB,aAAa;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,6CAA6C;EAC7C,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,+BAA+B;EAC/B,uCAAuC;EACvC,yDAAyD;EACzD,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;UACxB,wBAAwB;EAChC,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;EACpC,MAAM;EACN,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,yCAAyC;IACzC,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,QAAQ;IACR,cAAc;IACd,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;QACpB,qBAAqB;YACjB,uBAAuB;IAC/B,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,qDAAqD;IACrD,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;IACE,iDAAiD;EACnD;EACA;IACE,eAAe;EACjB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;QACnB,oBAAoB;YAChB,sBAAsB;EAChC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,iCAAiC;UACzB,yBAAyB;AACnC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,gDAAgD;EAChD,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,gDAAgD;EAChD,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,MAAM;EACN,OAAO;EACP,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;UAChB,gBAAgB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,wDAAwD;AAC1D;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,iDAAiD;EACjD,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,eAAe;EACf,mCAAmC;UAC3B,2BAA2B;EACnC,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sDAAsD;EACxD;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;;;;;CAKC;AACD;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,oDAAoD;UAC5C,4CAA4C;EACpD,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;MACzB,0BAA0B;UACtB,sBAAsB;EAC9B,sBAAsB;MAClB,mBAAmB;UACf,qBAAqB;AAC/B;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;EAChB;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,0BAA0B;UAClB,yBAAyB;EACjC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qBAAqB;UACb,oBAAoB;AAC9B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4DAA4D;EAC5D,oDAAoD;EACpD,oCAAoC;UAC5B,4BAA4B;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;;;;;;;;;;;EAYE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,MAAM;AACR;AACA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,MAAM;EACN,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,QAAQ;EACR,aAAa;EACb,UAAU;EACV,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,QAAQ;EACR,aAAa;EACb,OAAO;EACP,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gCAAgC;UACxB,wBAAwB;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;AACA;EACE,kFAAkF;UAC1E,0EAA0E;EAClF,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;UAC9B,8BAA8B;EACtC,eAAe;EACf,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,cAAc;EACd,2CAA2C;UACnC,mCAAmC;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,+LAA+L;EAC/L,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mCAAmC;EACnC,oDAAoD;UAC5C,4CAA4C;EACpD,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;MACzB,0BAA0B;UACtB,sBAAsB;EAC9B,mBAAmB;MACf,eAAe;EACnB,uBAAuB;MACnB,oBAAoB;UAChB,2BAA2B;EACnC,yBAAyB;MACrB,yBAAyB;EAC7B,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;UAC9B,8BAA8B;EACtC,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,UAAU;EACV,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;UACjC,iCAAiC;EACzC,kBAAkB;EAClB,cAAc;EACd,YAAY,EAAE,mGAAmG;EACjH,WAAW;EACX,eAAe,EAAE,kDAAkD;EACnE,gBAAgB,EAAE,0CAA0C;EAC5D,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;UAC9B,8BAA8B;EACtC,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,yBAAyB;MACrB,0BAA0B;UACtB,kBAAkB;EAC1B,oBAAoB;MAChB,cAAc;EAClB,0BAA0B;MACtB,aAAa;AACnB;;AAEA;EACE,2BAA2B;UACnB,mBAAmB;EAC3B,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;GACrB,qBAAqB;OACjB,iBAAiB;EACtB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,0DAA0D;EAC1D,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,WAAW;AACb;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,iDAAiD;EACjD,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;;EAKE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;EACxC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;EACxC,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,6BAA6B;EAC7B,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,QAAQ;AACR;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gDAAgD;UACxC,wCAAwC;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6CAA6C;UACrC,qCAAqC;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;IACd,cAAc;OACX,WAAW;EAChB,iBAAiB;MACb,aAAa;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0GAA0G;EAC1G,4EAA4E;AAC9E;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;;;EAGE,UAAU;EACV,iBAAiB;AACnB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;;;EAGE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;;EAGE,uBAAuB;AACzB;AACA;;;EAGE,0CAA0C;EAC1C,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,sDAAsD;UAC9C,8CAA8C;AACxD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;AACd;AACA;;EAEE,wBAAwB;UAChB,gBAAgB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;AACA;;;EAGE,wCAAwC;EACxC,wBAAwB;UAChB,gBAAgB;EACxB,2BAA2B;AAC7B;AACA;;;EAGE,wBAAwB;UAChB,gBAAgB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;EACA;IACE,SAAS;IACT,SAAS;IACT,QAAQ;EACV;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;EACA;IACE,SAAS;IACT,SAAS;IACT,QAAQ;EACV;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE;IACE,SAAS;IACT,WAAW;IACX,QAAQ;EACV;EACA;IACE,SAAS;IACT,WAAW;IACX,QAAQ;EACV;EACA;IACE,SAAS;IACT,QAAQ;IACR,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;IACZ,cAAc;IACd,QAAQ;EACV;EACA;IACE,SAAS;IACT,WAAW;IACX,QAAQ;EACV;EACA;IACE,SAAS;IACT,QAAQ;IACR,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,qGAAqG;UAC7F,6FAA6F;AACvG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;AACF;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;AACV;AACA;EACE,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;UACtB,sBAAsB;EAC9B,4BAA4B;EAC5B,6BAA6B;MACzB,0BAA0B;UACtB,sBAAsB;EAC9B,kBAAkB;EAClB,WAAW;EACX,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mCAAmC;UAC3B,2BAA2B;EACnC,yDAAoM;EACpM,YAAY;EACZ,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kDAAkD;UAC1C,0CAA0C;AACpD;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;UACtB,sBAAsB;EAC9B,mBAAmB;MACf,eAAe;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;UACvC,uCAAuC;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;UACtB,sBAAsB;EAC9B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;KACnB,mBAAmB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;KAChB,gBAAgB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,kBAAkB;AACpB;AACA;EACE,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,mBAAmB;MACf,WAAW;UACP,OAAO;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["@charset \"UTF-8\";\n\n.border-theme-white {\n  border: 1px solid var(--bs-theme-white-color);\n}\n\n.border-theme-white-2 {\n  border: 2px solid var(--bs-theme-white-color);\n}\n\n.breadcrumb-item + .breadcrumb-item:before {\n  content: \"\\f101\";\n  font-family: \"Line Awesome Free\";\n  font-weight: 900;\n}\n\n.btn-primary {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);\n}\n.btn-primary:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-secondary {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(168, 181, 209, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(168, 181, 209, 0.35);\n}\n.btn-secondary:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-success {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(13, 166, 132, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(13, 166, 132, 0.35);\n}\n.btn-success:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-info {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(65, 203, 216, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(65, 203, 216, 0.35);\n}\n.btn-info:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-warning {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(244, 161, 77, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(244, 161, 77, 0.35);\n}\n.btn-warning:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-danger {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(239, 52, 99, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(239, 52, 99, 0.35);\n}\n.btn-danger:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-pink {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(253, 60, 151, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(253, 60, 151, 0.35);\n}\n.btn-pink:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-purple {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(91, 88, 230, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(91, 88, 230, 0.35);\n}\n.btn-purple:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-blue {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(49, 103, 243, 0.35);\n}\n.btn-blue:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-light {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(244, 246, 249, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(244, 246, 249, 0.35);\n}\n.btn-light:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-dark {\n  -webkit-box-shadow: 0 1px 2px 0 rgba(37, 40, 45, 0.35);\n          box-shadow: 0 1px 2px 0 rgba(37, 40, 45, 0.35);\n}\n.btn-dark:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-soft-primary {\n  background-color: rgba(49, 103, 243, 0.15);\n  color: #3167f3;\n}\n.btn-soft-primary:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #3167f3;\n  color: #ffffff;\n}\n\n.btn-soft-secondary {\n  background-color: rgba(168, 181, 209, 0.15);\n  color: #a8b5d1;\n}\n.btn-soft-secondary:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #a8b5d1;\n  color: #ffffff;\n}\n\n.btn-soft-success {\n  background-color: rgba(13, 166, 132, 0.15);\n  color: #0da684;\n}\n.btn-soft-success:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #0da684;\n  color: #ffffff;\n}\n\n.btn-soft-info {\n  background-color: rgba(65, 203, 216, 0.15);\n  color: #41cbd8;\n}\n.btn-soft-info:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #41cbd8;\n  color: #ffffff;\n}\n\n.btn-soft-warning {\n  background-color: rgba(244, 161, 77, 0.15);\n  color: #f4a14d;\n}\n.btn-soft-warning:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #f4a14d;\n  color: #ffffff;\n}\n\n.btn-soft-danger {\n  background-color: rgba(239, 52, 99, 0.15);\n  color: #ef3463;\n}\n.btn-soft-danger:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #ef3463;\n  color: #ffffff;\n}\n\n.btn-soft-pink {\n  background-color: rgba(253, 60, 151, 0.15);\n  color: #fd3c97;\n}\n.btn-soft-pink:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #fd3c97;\n  color: #ffffff;\n}\n\n.btn-soft-purple {\n  background-color: rgba(91, 88, 230, 0.15);\n  color: #5b58e6;\n}\n.btn-soft-purple:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #5b58e6;\n  color: #ffffff;\n}\n\n.btn-soft-blue {\n  background-color: rgba(49, 103, 243, 0.15);\n  color: #3167f3;\n}\n.btn-soft-blue:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #3167f3;\n  color: #ffffff;\n}\n\n.btn-soft-light {\n  background-color: rgba(244, 246, 249, 0.15);\n  color: #f4f6f9;\n}\n.btn-soft-light:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #f4f6f9;\n  color: #ffffff;\n}\n\n.btn-soft-dark {\n  background-color: rgba(37, 40, 45, 0.15);\n  color: #25282d;\n}\n.btn-soft-dark:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #25282d;\n  color: #ffffff;\n}\n\n.text-gray-100 {\n  color: #f4f6f9;\n}\n\n.text-gray-200 {\n  color: #eaeff5;\n}\n\n.text-gray-300 {\n  color: #d9e1ec;\n}\n\n.text-gray-400 {\n  color: #c1cde0;\n}\n\n.text-gray-500 {\n  color: #a8b5d1;\n}\n\n.text-gray-600 {\n  color: #95a0c5;\n}\n\n.text-gray-700 {\n  color: #7a82b1;\n}\n\n.text-gray-800 {\n  color: #555b7e;\n}\n\n.text-gray-900 {\n  color: #25282d;\n}\n\n.btn-outline-light {\n  color: #7a82b1;\n  background-image: none;\n  background-color: transparent;\n  border-color: #d9e1ec;\n}\n\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  border-color: transparent;\n}\n\n.modal-header .btn-close {\n  font-size: 20px;\n}\n\nhtml[data-bs-theme=dark] .btn-light {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  --bs-btn-color: #f4f6f9;\n  --bs-btn-bg: #303231;\n  --bs-btn-border-color: #2b2d3b;\n  --bs-btn-hover-color: #f4f6f9;\n  --bs-btn-hover-bg: #343635;\n  --bs-btn-hover-border-color: #313341;\n  --bs-btn-focus-shadow-rgb: 75, 77, 88;\n  --bs-btn-active-color: #f4f6f9;\n  --bs-btn-active-bg: #343635;\n  --bs-btn-active-border-color: #313341;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #f4f6f9;\n  --bs-btn-disabled-bg: #2b2d3b;\n  --bs-btn-disabled-border-color: #2b2d3b;\n}\nhtml[data-bs-theme=dark] .btn-dark {\n  --bs-btn-color: #303231;\n  --bs-btn-bg: #f4f6f9;\n  --bs-btn-border-color: #f4f6f9;\n  --bs-btn-hover-color: #303231;\n  --bs-btn-hover-bg: #e8eaed;\n  --bs-btn-hover-border-color: #dcdde0;\n  --bs-btn-focus-shadow-rgb: 207, 209, 212;\n  --bs-btn-active-color: #303231;\n  --bs-btn-active-bg: #dcdde0;\n  --bs-btn-active-border-color: #cfd1d4;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #303231;\n  --bs-btn-disabled-bg: #f4f6f9;\n  --bs-btn-disabled-border-color: #f4f6f9;\n}\nhtml[data-bs-theme=dark] .btn-outline-light {\n  color: #c1cde0;\n  background-image: none;\n  background-color: transparent;\n  border-color: #555b7e;\n}\nhtml[data-bs-theme=dark] .btn-outline-light:active {\n  color: #eaeff5;\n  background-image: none;\n  background-color: transparent;\n  border-color: #7a82b1;\n}\n\n.card {\n  -webkit-box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.03);\n          box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.03);\n  margin-bottom: 1.5rem;\n}\n.card .card-header {\n  border-bottom: none;\n  padding-top: var(--bs-card-spacer-x);\n}\n.card .card-header .card-title {\n  margin-bottom: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--bs-heading-color);\n}\n\n.card-h-100 {\n  height: calc(100% - 1.5rem);\n}\n\n.offer-card {\n  /*background-image: url(\"../images/extra/pet-bg.png\");*/\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: #000000;\n}\n\n.dropdown-menu {\n  -webkit-box-shadow: 0 5px 5px rgba(61, 71, 81, 0.1);\n          box-shadow: 0 5px 5px rgba(61, 71, 81, 0.1);\n}\n\n.dropstart .dropdown-toggle::before,\n.dropend .dropdown-toggle::after,\n.dropup .dropdown-toggle::after,\n.dropdown-toggle::after {\n  display: none;\n}\n\n.dropdown-lg {\n  width: 320px;\n}\n\nlabel {\n  color: var(--bs-label-color);\n  vertical-align: middle;\n}\n\n.ql-editor {\n  min-height: 300px;\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.ql-snow .ql-stroke {\n  stroke: var(--bs-label-color);\n}\n.ql-snow .ql-picker-options {\n  background-color: var(--bs-topbar-bg);\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label:before,\n.ql-snow .ql-picker.ql-header .ql-picker-item:before {\n  color: var(--bs-label-color);\n}\n\n.ql-toolbar {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n.ql-toolbar.ql-snow {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n  border: 1px solid var(--bs-border-color);\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: var(--bs-border-color);\n}\n\n.ql-container.ql-snow {\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border: 1px solid var(--bs-border-color);\n}\n\n.uppy-Root {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.uppy-DragDrop-container {\n  background-color: var(--bs-secondary-bg);\n}\n\n.uppy-Dashboard-inner {\n  background-color: var(--bs-secondary-bg);\n  border: 1px solid var(--bs-border-color);\n  height: 250px !important;\n}\n\n[data-uppy-drag-drop-supported=true] .uppy-Dashboard-AddFiles {\n  border: 1px dashed var(--bs-border-color);\n}\n\n.uppy-Dashboard-AddFiles-title {\n  color: var(--bs-body-color);\n}\n\n.uppy-DragDrop-container:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.uppy-DragDrop--isDragDropSupported {\n  border: 2px dashed #d9e1ec;\n}\n\n.uppy-DragDrop-label {\n  color: #25282d;\n}\n\n.uppy-StatusBar.is-waiting .uppy-StatusBar-actions {\n  background-color: var(--bs-card-bg);\n}\n\n.uppy-StatusBar:not([aria-hidden=true]).is-waiting {\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.uppy-Dashboard-Item-name,\n.uppy-DashboardContent-title {\n  color: var(--bs-label-color);\n}\n\n.uppy-StatusBar,\n.uppy-DashboardContent-bar {\n  background-color: var(--bs-card-bg);\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.uppy-Dashboard-Item {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.uppy-Dashboard-Item-action--remove {\n  color: #3167f3;\n}\n.uppy-Dashboard-Item-action--remove:hover, .uppy-Dashboard-Item-action--remove:focus {\n  color: #1955f2;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.uppy-DashboardContent-addMore:focus,\n.uppy-DashboardContent-back:focus,\n.uppy-DashboardContent-save:focus {\n  background-color: rgba(168, 181, 209, 0.1);\n}\n\n.uppy-c-btn-primary:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\ninput.add-file-input {\n  position: absolute;\n  opacity: 0;\n  right: 0;\n  top: 0;\n}\n\n.form-switch-primary .form-check-input:checked {\n  background-color: #3167f3;\n  border-color: #3167f3;\n}\n\n.form-switch-secondary .form-check-input:checked {\n  background-color: #a8b5d1;\n  border-color: #a8b5d1;\n}\n\n.form-switch-success .form-check-input:checked {\n  background-color: #0da684;\n  border-color: #0da684;\n}\n\n.form-switch-info .form-check-input:checked {\n  background-color: #41cbd8;\n  border-color: #41cbd8;\n}\n\n.form-switch-warning .form-check-input:checked {\n  background-color: #f4a14d;\n  border-color: #f4a14d;\n}\n\n.form-switch-danger .form-check-input:checked {\n  background-color: #ef3463;\n  border-color: #ef3463;\n}\n\n.form-switch-pink .form-check-input:checked {\n  background-color: #fd3c97;\n  border-color: #fd3c97;\n}\n\n.form-switch-purple .form-check-input:checked {\n  background-color: #5b58e6;\n  border-color: #5b58e6;\n}\n\n.form-switch-blue .form-check-input:checked {\n  background-color: #3167f3;\n  border-color: #3167f3;\n}\n\n.form-switch-light .form-check-input:checked {\n  background-color: #f4f6f9;\n  border-color: #f4f6f9;\n}\n\n.form-switch-dark .form-check-input:checked {\n  background-color: #25282d;\n  border-color: #25282d;\n}\n\n.selectr-option {\n  padding: 0.375rem 1.5rem;\n  color: var(--bs-dropdown-link-color);\n  background-color: transparent;\n}\n.selectr-option.selected {\n  background-color: var(--bs-light);\n}\n.selectr-option:hover {\n  color: var(--bs-body-color);\n  background-color: var(--bs-light);\n}\n.selectr-option.active {\n  color: var(--bs-body-color);\n  background-color: var(--bs-light);\n  text-decoration: none;\n}\n\n.selectr-options-container,\n.selectr-selected {\n  width: 100%;\n  padding: 0.517rem 0.95rem;\n  font-size: 0.812rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: var(--bs-card-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n}\n\n.selectr-container.multiple.has-selected .selectr-selected {\n  padding: 0 0.95rem;\n  padding-top: calc(0.517rem - 2px);\n  padding-bottom: calc(0.517rem - 2px);\n}\n.selectr-container.multiple.has-selected .selectr-selected:focus-visible {\n  outline: none;\n}\n.selectr-container.open .selectr-selected {\n  border-color: var(--bs-border-color) var(--bs-border-color) transparent;\n  border-radius: 3px 3px 0 0;\n}\n.selectr-container.open .selectr-selected:focus-visible {\n  outline: none;\n}\n\n.selectr-tag-input {\n  background-color: var(--bs-card-bg);\n  padding: 0;\n}\n.selectr-tag-input:focus-visible {\n  outline: none;\n}\n\n.taggable .selectr-selected {\n  padding: 0.517rem 0.95rem;\n}\n\n.selectr-input {\n  border-color: var(--bs-border-color) !important;\n  background-color: var(--bs-card-bg);\n}\n.selectr-input:focus-visible {\n  outline: none;\n}\n\n.selectr-tag {\n  background: #3167f3;\n  border-radius: 3px;\n}\n\n.selectr-tag-remove::after,\n.selectr-tag-remove::before {\n  width: 1px;\n}\n\n.datepicker.active {\n  display: inline-block;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 4px;\n}\n\n.datepicker-dropdown.datepicker-orient-top {\n  padding-bottom: 0;\n}\n\n.datepicker-header .datepicker-controls .button {\n  font-weight: 500;\n}\n\n.datepicker-controls .button {\n  font-size: 15px;\n  border: 1px solid var(--bs-border-color);\n  background-color: var(--bs-body-bg);\n  color: #7a82b1;\n}\n\n.datepicker-view .dow {\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.datepicker-picker {\n  background-color: var(--bs-body-bg);\n}\n.datepicker-picker span {\n  border-radius: 25px;\n}\n\n.datepicker-cell.focused:not(.selected),\n.datepicker-cell:not(.disabled):hover {\n  background-color: #3167f3;\n  color: #ffffff;\n}\n\n.example__complete {\n  display: none;\n  margin-left: 5px;\n}\n\n.example__complete::after {\n  content: \"✔\";\n}\n\n#form-validation-2 small {\n  display: none;\n  color: #ef3463;\n}\n#form-validation-2 small.error {\n  display: block;\n}\n\n.form-control.error {\n  border-color: #ef3463;\n}\n.form-control.success {\n  border-color: #0da684;\n}\n\n.preview-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: auto;\n}\n.preview-box .preview-content {\n  width: auto;\n  height: 50px;\n  max-width: 100%;\n  border-radius: 5px;\n}\n\n.dynamic-select .dynamic-select-header {\n  border: none !important;\n}\n.dynamic-select .dynamic-select-header,\n.dynamic-select .dynamic-select-option {\n  height: calc(1.5em + 1.034rem + calc(var(--bs-border-width) * 2)) !important;\n  padding: 0.517rem 2.85rem 0.517rem 0.95rem !important;\n  font-size: 0.812rem !important;\n  color: var(--bs-body-color) !important;\n}\n\n.modal-content {\n  border: none;\n}\n\n.modal-header {\n  background-color: #25282d;\n}\n.modal-header .modal-title {\n  color: #ffffff;\n  font-size: 15px;\n}\n.modal-header .btn-close {\n  font-size: 20px;\n}\n\nbody {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}\n\n.page-wrapper .page-content {\n  width: 100%;\n  margin-right: var(--bs-startbar-width);\n  position: relative;\n  min-height: calc(100vh - var(--bs-topbar-height));\n  padding: 0 0.75rem 68px 0.75rem;\n  margin-top: var(--bs-topbar-height);\n}\n.page-wrapper .page-content .page-title-box {\n  padding: 1rem 0;\n}\n.page-wrapper .page-content .page-title-box .page-title {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 600;\n}\n.page-wrapper .page-content .page-title-box .breadcrumb .breadcrumb-item a {\n  color: #7a82b1;\n  font-weight: 400;\n  font-size: 13px;\n}\n\n@media (min-width: 680px) {\n  .page-wrapper {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n.shape {\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.shape > svg {\n  -webkit-transform: scale(2);\n          transform: scale(2);\n  width: 100%;\n  height: auto;\n  -webkit-transform-origin: top center;\n          transform-origin: top center;\n}\n\n.ex-page-content h1 {\n  font-size: 98px;\n  font-weight: 700;\n  text-shadow: rgba(137, 151, 189, 0.2) 1px 1px, rgba(137, 151, 189, 0.2) 2px 2px, rgba(137, 151, 189, 0.2) 3px 3px;\n}\n\n.img-group .user-avatar:hover {\n  z-index: 2;\n}\n\n.task-accordion.accordion-item:not(:first-of-type) {\n  border-top: 1px;\n}\n\n.color-bg {\n  /*background-image: url(\"../images/extra/color-bg-2.jpg\");*/\n  background-position: top center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.img-bg {\n  background-image: url(\"../images/card-bg.jpg\");\n  background-position: 0 20%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 180px;\n}\n\n.social {\n  border: 1px solid #a8b5d1;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.social i {\n  color: #a8b5d1;\n}\n.social.twitter:hover {\n  border-color: #1da1f2;\n  background-color: #1da1f2;\n}\n.social.twitter:hover i {\n  color: #ffffff;\n}\n.social.instagram:hover {\n  border-color: #f09433;\n  background: #f09433;\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n}\n.social.instagram:hover i {\n  color: #ffffff;\n}\n.social.facebook:hover {\n  border-color: #1877f2;\n  background-color: #1877f2;\n}\n.social.facebook:hover i {\n  color: #ffffff;\n}\n\n.list-arrow {\n  position: relative;\n}\n.list-arrow::before {\n  content: \"\\f178\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 900;\n  color: #3167f3;\n  position: absolute;\n  left: -22px;\n}\n\n.bg-welcome-img {\n  /*background-image: url(\"../images/extra/welcome.jpg\");*/\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.bg-globe-img {\n  /*background-image: url(\"../images/extra/globe.png\");*/\n  background-position: right;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.bg-corner-img {\n  /*background-image: url(\"../images/extra/corner.png\");*/\n  background-position: right;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.progress {\n  background-color: var(--bs-border-color);\n}\n\n/* Progressbar Vertical */\n.progress-vertical {\n  min-height: 250px;\n  height: 250px;\n  width: 8px;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.progress-vertical .progress-bar {\n  width: 100%;\n}\n\n.progress-vertical-bottom {\n  min-height: 250px;\n  height: 250px;\n  position: relative;\n  width: 8px;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.progress-vertical-bottom .progress-bar {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n}\n\n.progress-vertical.progress-sm,\n.progress-vertical-bottom.progress-sm {\n  width: 5px !important;\n}\n.progress-vertical.progress-sm .progress-bar,\n.progress-vertical-bottom.progress-sm .progress-bar {\n  font-size: 8px;\n  line-height: 5px;\n}\n.progress-vertical.progress-md,\n.progress-vertical-bottom.progress-md {\n  width: 15px !important;\n}\n.progress-vertical.progress-md .progress-bar,\n.progress-vertical-bottom.progress-md .progress-bar {\n  font-size: 10.8px;\n  line-height: 14.4px;\n}\n.progress-vertical.progress-lg,\n.progress-vertical-bottom.progress-lg {\n  width: 20px !important;\n}\n.progress-vertical.progress-lg .progress-bar,\n.progress-vertical-bottom.progress-lg .progress-bar {\n  font-size: 12px;\n  line-height: 20px;\n}\n\n.progress-icon-spin {\n  font-size: 36px;\n}\n\n:root {\n  --bs-topbar-height: 75px;\n  --bs-topbar-bg: #f9fbfd;\n  --bs-topbar-b-border-color: #e3ebf6;\n  --bs-topbar-nav-icon-bg: #fff;\n  --bs-topbar-nav-icon-color: #424d65;\n  --bs-startbar-width: 270px;\n  --bs-startbar-collapsed-width: 70px;\n  --bs-startbar-bg: #fff;\n  --bs-startbar-e-border-color: #e3ebf6;\n  --bs-menu-icon-color: #96a0b5;\n  --bs-menu-link-color: #061237;\n  --bs-menu-link-active-bg-color: #f9fbfd;\n  --bs-nav-link-disc-color: #8997bd;\n  --bs-menu-label-color: #a0a5b3;\n  --bs-label-color: #656d9a;\n  --bs-text-muted: var(--bs-secondary-color);\n  --bs-box-shadow-sm: 0 2px 2px rgba(61, 71, 81, 0.05);\n  --bs-card-bg: var(--bs-secondary-bg);\n  --bs-theme-white-color: #ffffff;\n  --bs-border-secondary: #95a0c5;\n  --bs-table-head-bg: #f4f6f9;\n}\n\nhtml[data-bs-theme=dark] {\n  --bs-light: #303231;\n  --bs-light-rgb: 48, 50, 49;\n  --bs-dark: #f4f6f9;\n  --bs-dark-rgb: 244, 246, 249;\n  --bs-label-color: #9797a5;\n  --bs-theme-white-color: #2e2e31;\n  --bs-body-color: #d9e1ec;\n  --bs-text-muted: #aab0b9;\n  --bs-box-shadow-sm: 0 2px 2px rgba(61, 71, 81, 0.05);\n  --bs-card-bg: #151821;\n  --bs-topbar-bg: #141824;\n  --bs-topbar-b-border-color: #333547;\n  --bs-topbar-nav-icon-bg: #222735;\n  --bs-topbar-nav-icon-color: #a1a8bd;\n  --bs-secondary: #c3c3c3;\n  --bs-secondary-rgb: 195, 195, 195;\n  --bs-border-secondary: #333645;\n  --bs-table-head-bg: #222735;\n  --bs-startbar-bg: #141824;\n  --bs-startbar-e-border-color: #333547;\n  --bs-menu-icon-color: #5e748b;\n  --bs-menu-link-color: #a1a8bd;\n  --bs-menu-link-active-bg-color: rgba(249, 251, 253, 0.04);\n  --bs-menu-link-hover-color: #ffffff;\n  --bs-nav-link-disc-color: #8997bd;\n  --bs-menu-label-color: #a0a5b3;\n}\n\nhtml[data-startbar=dark] {\n  --bs-startbar-bg: #141824;\n  --bs-startbar-e-border-color: #333547;\n  --bs-menu-icon-color: #5e748b;\n  --bs-menu-link-color: #a1a8bd;\n  --bs-menu-link-active-bg-color: rgba(249, 251, 253, 0.04);\n  --bs-menu-link-hover-color: #ffffff;\n  --bs-nav-link-disc-color: #8997bd;\n  --bs-menu-label-color: #a0a5b3;\n  --bs-dark: #f4f6f9;\n  --bs-box-shadow-sm: 0 2px 2px rgba(61, 71, 81, 0.05);\n}\n\n.spinner-border.spinner-border-custom-1 {\n  border: 5px double currentColor;\n  border-right-color: transparent;\n}\n.spinner-border.spinner-border-custom-2 {\n  border: 5px dotted currentColor;\n  border-right-color: transparent;\n}\n.spinner-border.spinner-border-custom-3 {\n  border: 5px groove currentColor;\n  border-right-color: transparent;\n}\n.spinner-border.spinner-border-custom-4 {\n  border: 5px dashed currentColor;\n  border-right-color: transparent;\n}\n.spinner-border.spinner-border-custom-5 {\n  border: 5px outset currentColor;\n  border-right-color: transparent;\n}\n\n.table th {\n  font-weight: 500;\n  vertical-align: middle;\n}\n.table td {\n  font-weight: 400;\n  vertical-align: middle;\n}\n.table.border-dashed th {\n  font-weight: 500;\n  border-top: 1px dashed var(--bs-border-color);\n}\n.table.border-dashed td {\n  border-top: 1px dashed var(--bs-border-color);\n}\n.table.border-dashed thead th {\n  border-bottom: 1px dashed var(--bs-border-color);\n}\n.table tbody tr:last-child th,\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table thead th {\n  border-bottom: none;\n}\n.table thead th:last-child {\n  border-radius: 8px 0 0 8px;\n}\n.table thead th:first-child {\n  border-radius: 0 8px 8px 0;\n}\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table th,\n.table td {\n  vertical-align: middle;\n}\n\n.table tbody,\n.table td,\n.table tfoot,\n.table th,\n.table thead,\n.table tr {\n  border-style: dashed;\n}\n\n.datatable-table > thead {\n  background-color: var(--bs-light) !important;\n}\n.datatable-table > thead > tr > th {\n  color: var(--bs-body-color);\n  font-weight: 500;\n  background-color: var(--bs-table-head-bg);\n}\n\n.dataTable-top,\n.datatable-top {\n  padding-top: 0;\n}\n\n.dataTable-bottom,\n.datatable-bottom {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding: 0;\n}\n\n.dataTable-table > tfoot > tr > td,\n.dataTable-table > tfoot > tr > th,\n.dataTable-table > thead > tr > td,\n.dataTable-table > thead > tr > th,\n.dataTable-table > tbody > tr > td,\n.dataTable-table > tbody > tr > th,\n.datatable-table > tfoot > tr > td,\n.datatable-table > tfoot > tr > th,\n.datatable-table > thead > tr > td,\n.datatable-table > thead > tr > th,\n.datatable-table > tbody > tr > td,\n.datatable-table > tbody > tr > th {\n  padding: 0.5rem 0.75rem;\n  vertical-align: middle;\n}\n.dataTable-table > tfoot > tr > th,\n.dataTable-table > thead > tr > th,\n.dataTable-table > tbody > tr > th,\n.datatable-table > tfoot > tr > th,\n.datatable-table > thead > tr > th,\n.datatable-table > tbody > tr > th {\n  border-bottom: none;\n}\n\n.dataTable-sorter::before,\n.datatable-sorter::before {\n  border-top: 4px solid var(--bs-border-color);\n  opacity: 1;\n  left: 4px;\n  right: auto;\n}\n\n.dataTable-sorter::after,\n.datatable-sorter::after {\n  border-bottom: 4px solid var(--bs-border-color);\n  opacity: 1;\n  left: 4px;\n  right: auto;\n}\n\n.dataTable-sorter::before {\n  bottom: 0;\n}\n\n.datatable-editor-action .mdi {\n  margin-right: 5px;\n  color: #95a0c5;\n}\n\n.dataTable-selector,\n.datatable-selector {\n  background-color: var(--bs-card-bg);\n  color: var(--bs-body-color);\n  border-color: var(--bs-border-color);\n  border-radius: 4px;\n  /*padding-left: 10px;*/\n}\n.dataTable-selector:focus-visible,\n.datatable-selector:focus-visible {\n  outline: none;\n}\n\n.datatable-editor-input,\n.dataTable-input,\n.datatable-input {\n  background-color: var(--bs-card-bg);\n  color: var(--bs-body-color);\n  border: 1px solid var(--bs-border-color);\n  border-radius: 4px;\n}\n.datatable-editor-input:focus,\n.dataTable-input:focus,\n.datatable-input:focus {\n  border-color: #3167f3;\n}\n.datatable-editor-input:focus-visible,\n.dataTable-input:focus-visible,\n.datatable-input:focus-visible {\n  outline: none;\n}\n\n.datatable-wrapper.no-footer .datatable-container {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.datatable-pagination a,\n.datatable-pagination button {\n  margin-left: 0;\n}\n.datatable-pagination .datatable-active a,\n.datatable-pagination .datatable-active button,\n.datatable-pagination .datatable-active a:focus,\n.datatable-pagination .datatable-active a:hover,\n.datatable-pagination .datatable-active button:focus,\n.datatable-pagination .datatable-active button:hover {\n  color: #ffffff;\n  background-color: #3167f3;\n  border-color: #3167f3;\n}\n.datatable-pagination a:hover,\n.datatable-pagination button:hover {\n  color: var(--bs-link-hover-color);\n  background-color: var(--bs-tertiary-bg);\n  border-color: var(--bs-border-color);\n}\n\n.datatable-pagination-list-item .datatable-pagination-list-item-link {\n  position: relative;\n  display: block;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.812rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-card-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n}\n\n.datatable-pagination-list-item:first-child .datatable-pagination-list-item-link {\n  border-top-right-radius: var(--bs-border-radius);\n  border-bottom-right-radius: var(--bs-border-radius);\n}\n\n.datatable-pagination-list-item:last-child .datatable-pagination-list-item-link {\n  border-top-left-radius: var(--bs-border-radius);\n  border-bottom-left-radius: var(--bs-border-radius);\n}\n\n.datatable-table th button,\n.datatable-pagination-list button {\n  color: var(--bs-body-color);\n  text-align: start;\n}\n\n.checkbox-all thead tr th:first-child button::after, .checkbox-all thead tr th:first-child button::before, .checkbox-all thead tr th:last-child button::after, .checkbox-all thead tr th:last-child button::before {\n  display: none;\n}\n\n.dataTable-pagination a {\n  position: relative;\n  display: block;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.812rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-card-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  margin: 0;\n}\n.dataTable-pagination a:hover {\n  color: var(--bs-link-hover-color);\n  background-color: var(--bs-tertiary-bg);\n  border-color: var(--bs-border-color);\n}\n.dataTable-pagination .active a,\n.dataTable-pagination .active a:focus,\n.dataTable-pagination .active a:hover {\n  color: #ffffff;\n  background-color: #3167f3;\n  border-color: #3167f3;\n}\n.dataTable-pagination li:first-child a {\n  border-top-left-radius: var(--bs-border-radius);\n  border-bottom-left-radius: var(--bs-border-radius);\n}\n.dataTable-pagination li:last-child a {\n  border-top-right-radius: var(--bs-border-radius);\n  border-bottom-right-radius: var(--bs-border-radius);\n}\n\n.dataTable-wrapper.no-footer .dataTable-container {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.datatable-editor-menu {\n  background-color: var(--bs-card-bg);\n}\n.datatable-editor-menu a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.datatable-editor-menu a:hover {\n  color: var(--bs-link-hover-color);\n  background-color: var(--bs-tertiary-bg);\n  border-color: var(--bs-border-color);\n}\n\n.datatable-editor-separator {\n  border-bottom: 1px solid var(--bs-border-color);\n  margin: 0;\n}\n\nhtml[data-bs-theme=dark] .datatable-container thead,\nhtml[data-bs-theme=dark] .table-light {\n  --bs-table-color: #ffffff;\n  --bs-table-bg: #23252d;\n  --bs-table-border-color: #40424f;\n  --bs-table-striped-bg: #363845;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #40424f;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #3b3d4a;\n  --bs-table-hover-color: #ffffff;\n}\n\n.custom-tooltip {\n  --bs-tooltip-bg: var(--bs-purple);\n  --bs-tooltip-color: var(--bs-white);\n}\n\n.custom-popover {\n  --bs-popover-max-width: 200px;\n  --bs-popover-border-color: var(--bs-purple);\n  --bs-popover-header-bg: var(--bs-purple);\n  --bs-popover-header-color: var(--bs-white);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 0.5rem;\n}\n\n.nav-tabs-custom .nav.nav-tabs {\n  border-bottom: none;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.nav-tabs-custom .nav.nav-tabs .nav-item {\n  border: 2px solid rgba(168, 181, 209, 0.2);\n  border-radius: 4px;\n  margin-right: 5px;\n}\n.nav-tabs-custom .nav.nav-tabs .nav-link {\n  border-radius: 3px;\n  padding: 10px 14px;\n}\n.nav-tabs-custom .nav.nav-tabs .nav-link.active {\n  background-color: rgba(49, 103, 243, 0.08);\n  border-color: #3167f3;\n  color: #3167f3;\n}\n.nav-tabs-custom .nav.nav-tabs .nav-link.active i {\n  color: #3167f3;\n}\n.nav-tabs-custom .nav.nav-tabs .nav-link i {\n  font-size: 24px;\n  vertical-align: middle;\n  color: #a8b5d1;\n}\n\n.tooltip-primary {\n  --bs-tooltip-bg: var(--bs-primary);\n}\n\n.tooltip-secondary {\n  --bs-tooltip-bg: var(--bs-secondary);\n}\n\n.tooltip-success {\n  --bs-tooltip-bg: var(--bs-success);\n}\n\n.tooltip-info {\n  --bs-tooltip-bg: var(--bs-info);\n}\n\n.tooltip-warning {\n  --bs-tooltip-bg: var(--bs-warning);\n}\n\n.tooltip-danger {\n  --bs-tooltip-bg: var(--bs-danger);\n}\n\n.tooltip-pink {\n  --bs-tooltip-bg: var(--bs-pink);\n}\n\n.tooltip-purple {\n  --bs-tooltip-bg: var(--bs-purple);\n}\n\n.tooltip-blue {\n  --bs-tooltip-bg: var(--bs-blue);\n}\n\n.tooltip-light {\n  --bs-tooltip-bg: var(--bs-light);\n}\n\n.tooltip-dark {\n  --bs-tooltip-bg: var(--bs-dark);\n}\n\n.nav-tabs.nav-tabs-custom {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  border-color: transparent;\n  border-bottom: 1px solid #3167f3 !important;\n}\n.nav-tabs .nav-link:hover {\n  border-color: transparent;\n}\n\n.fs-9 {\n  font-size: 9px;\n}\n\n.fs-10 {\n  font-size: 10px;\n}\n\n.fs-11 {\n  font-size: 11px;\n}\n\n.fs-12 {\n  font-size: 12px;\n}\n\n.fs-13 {\n  font-size: 13px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.fs-15 {\n  font-size: 15px;\n}\n\n.fs-16 {\n  font-size: 16px;\n}\n\n.fs-18 {\n  font-size: 18px !important;\n}\n\n.fs-20 {\n  font-size: 20px;\n}\n\n.fs-22 {\n  font-size: 22px !important;\n}\n\n.fs-24 {\n  font-size: 24px;\n}\n\n.fs-26 {\n  font-size: 26px;\n}\n\n.fs-28 {\n  font-size: 28px;\n}\n\n.fs-30 {\n  font-size: 30px;\n}\n\n.h-80 {\n  height: 300px;\n}\n\n.mt-n6 {\n  margin-top: -100px;\n}\n\n.mt-n52 {\n  margin-top: -52px;\n}\n\n.ms-45 {\n  margin-left: 45px;\n}\n\n.trans-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.border-dashed {\n  border: 1px dashed;\n}\n\n.border-theme-color {\n  border-color: var(--bs-border-color);\n}\n\n.border-dashed-bottom {\n  border-bottom: 1px dashed var(--bs-border-color);\n}\n\n.border-dashed-top {\n  border-top: 1px dashed var(--bs-border-color);\n}\n\n.border-body-color {\n  border-color: #f9fbfd;\n}\n\n.border-card-bg {\n  border-color: var(--bs-secondary-bg) !important;\n}\n\n.border-secondary {\n  border-color: var(--bs-border-secondary) !important;\n}\n\n.bg-blue-subtle {\n  background-color: var(--bs-blue-bg-subtle);\n}\n\n.bg-pink-subtle {\n  background-color: var(--bs-pink-bg-subtle);\n}\n\n.bg-purple-subtle {\n  background-color: var(--bs-purple-bg-subtle);\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.thumb-xs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.thumb-sm {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 24px !important;\n  width: 24px !important;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.thumb-md {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 36px;\n  width: 36px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.thumb-lg {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 48px;\n  width: 48px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.thumb-xl {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 60px;\n  width: 60px;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.thumb-xxl {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 80px;\n  width: 80px;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.card-bg {\n  background-color: var(--bs-secondary-bg);\n}\n\n.text-card-bg {\n  color: var(--bs-secondary-bg);\n}\n\n.flex-basis-0 {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n}\n\nhr.hr-dashed {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px dashed var(--bs-border-color);\n  height: 0;\n  overflow: visible;\n  opacity: 1;\n}\n\n[class*=\" iconoir-\"]::before,\n[class^=iconoir-]::before {\n  stroke-width: 8px;\n}\n\n.icon-demo-content {\n  text-align: center;\n}\n.icon-demo-content i {\n  display: block;\n  font-size: 30px;\n  margin: 0 auto 5px;\n  color: #a8b5d1;\n}\n.icon-demo-content svg {\n  display: block;\n  font-size: 30px;\n  margin: 0 auto 5px;\n  color: #95a0c5;\n}\n.icon-demo-content .col-sm-6 {\n  margin-bottom: 40px;\n}\n.icon-demo-content .col-sm-6:hover i {\n  color: #3167f3;\n}\n.icon-demo-content .col-sm-6:hover path:nth-of-type(1) {\n  fill: #3167f3;\n}\n.icon-demo-content .col-sm-6:hover path:nth-of-type(2) {\n  fill: var(--bs-secondary-color);\n}\n\n.bg-soft-primary {\n  background-color: rgba(49, 103, 243, 0.15);\n  color: #3167f3;\n}\n\n.bg-soft-secondary {\n  background-color: rgba(168, 181, 209, 0.15);\n  color: #a8b5d1;\n}\n\n.bg-soft-success {\n  background-color: rgba(13, 166, 132, 0.15);\n  color: #0da684;\n}\n\n.bg-soft-info {\n  background-color: rgba(65, 203, 216, 0.15);\n  color: #41cbd8;\n}\n\n.bg-soft-warning {\n  background-color: rgba(244, 161, 77, 0.15);\n  color: #f4a14d;\n}\n\n.bg-soft-danger {\n  background-color: rgba(239, 52, 99, 0.15);\n  color: #ef3463;\n}\n\n.bg-soft-pink {\n  background-color: rgba(253, 60, 151, 0.15);\n  color: #fd3c97;\n}\n\n.bg-soft-purple {\n  background-color: rgba(91, 88, 230, 0.15);\n  color: #5b58e6;\n}\n\n.bg-soft-blue {\n  background-color: rgba(49, 103, 243, 0.15);\n  color: #3167f3;\n}\n\n.bg-soft-light {\n  background-color: rgba(244, 246, 249, 0.15);\n  color: #f4f6f9;\n}\n\n.bg-soft-dark {\n  background-color: rgba(37, 40, 45, 0.15);\n  color: #25282d;\n}\n\n.startbar {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: var(--bs-startbar-width);\n  background-color: var(--bs-startbar-bg);\n  border-right: 1px solid var(--bs-startbar-e-border-color);\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  z-index: 1005;\n}\n.startbar .brand {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: sticky;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  padding: 0 20px;\n  width: 100%;\n  height: var(--bs-topbar-height);\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.startbar .brand .logo-sm {\n  height: 28px;\n  display: none;\n}\n.startbar .brand .logo-lg {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  margin-left: 4px;\n  height: 28px;\n}\n.startbar .startbar-menu {\n  padding-bottom: var(--bs-topbar-height);\n  height: 100vh;\n}\n.startbar .startbar-menu .startbar-collapse {\n  padding: 0 16px 16px;\n  height: calc(100vh - 75px);\n  overflow-y: auto;\n}\n.startbar .startbar-menu .navbar-nav .menu-label {\n  text-transform: uppercase;\n  white-space: nowrap;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: var(--bs-menu-label-color);\n  padding: 14px 8px 14px 20px;\n  text-align: start;\n  letter-spacing: 1px;\n}\n.startbar .startbar-menu .navbar-nav .menu-label small {\n  display: none;\n}\n.startbar .startbar-menu .navbar-nav .nav-item.active {\n  border-radius: 0.4rem;\n}\n.startbar .startbar-menu .navbar-nav .nav-item.active .nav-link.active {\n  color: #3167f3;\n  background-color: var(--bs-menu-link-active-bg-color);\n}\n.startbar .startbar-menu .navbar-nav .nav-item.active .nav-link.active .menu-icon {\n  color: #3167f3;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link {\n  position: relative;\n  color: var(--bs-menu-link-color);\n  font-size: 13px;\n  font-weight: 500;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 10px;\n  padding: 10px 16px;\n  line-height: 20px;\n  margin-bottom: 3px;\n  border: 1px solid transparent;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link:hover, .startbar .startbar-menu .navbar-nav .nav-item .nav-link.active {\n  color: var(--bs-menu-link-hover-color);\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link:hover i, .startbar .startbar-menu .navbar-nav .nav-item .nav-link.active i {\n  color: var(--bs-menu-link-hover-color);\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {\n  display: block;\n  content: \"\\f105\";\n  font-family: \"Line Awesome Free\";\n  font-weight: 900;\n  margin-right: auto;\n  line-height: 20px;\n  -webkit-transition: -webkit-transform 0.2s;\n  transition: -webkit-transform 0.2s;\n  transition: transform 0.2s;\n  transition: transform 0.2s, -webkit-transform 0.2s;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true] {\n  border-radius: 10px;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  color: #3167f3;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true] i,\n.startbar .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse][aria-expanded=true] span {\n  color: #3167f3;\n  font-weight: 600;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav {\n  position: relative;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav:before {\n  content: \"\";\n  position: absolute;\n  width: 0.125rem;\n  height: calc(100% - 0.25rem);\n  background: rgba(137, 151, 189, 0.2);\n  top: 0;\n  right: 26px;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav .nav-item {\n  margin-left: 36px;\n}\n.startbar .startbar-menu .navbar-nav .nav-item .nav .nav-item .nav-link {\n  padding: 6px 16px 6px 16px;\n}\n.startbar .startbar-menu .menu-icon {\n  font-size: 20px;\n  /*margin-left: 16px;*/\n  color: var(--bs-menu-icon-color);\n}\n\n.logo-light {\n  display: none;\n}\n\n.logo-dark {\n  display: inline-block;\n}\n\nhtml[data-startbar=dark] .logo-light,\nhtml[data-bs-theme=dark] .logo-light {\n  display: inline-block;\n}\nhtml[data-startbar=dark] .logo-dark,\nhtml[data-bs-theme=dark] .logo-dark {\n  display: none;\n}\n\n@media (min-width: 1200px) {\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) {\n    width: var(--bs-startbar-collapsed-width);\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand {\n    width: var(--bs-startbar-collapsed-width);\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand .logo {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand .logo .logo-lg {\n    width: 0;\n    margin-left: 0;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .brand .logo .logo-sm {\n    display: inline-block;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .menu-label {\n    text-align: center;\n    font-weight: 600;\n    padding: 0;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .menu-label span {\n    display: none;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .menu-label small {\n    display: inline-block;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding: 10px 18px;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link span {\n    display: none;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after, body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=true]:after {\n    display: none;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .nav-link .menu-icon {\n    margin-right: 0;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .navbar-nav .nav-item .collapse {\n    display: none;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .starbar-user {\n    width: calc(var(--bs-startbar-collapsed-width) - 1px);\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .starbar-user img.thumb-lg {\n    height: 40px;\n    width: 40px;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .startbar-menu .starbar-user span {\n    display: none !important;\n  }\n  body[data-sidebar-size=collapsed] .startbar:not(:hover) .update-msg {\n    display: none;\n  }\n  body[data-sidebar-size=collapsed] .page-wrapper .page-content {\n    margin-right: var(--bs-startbar-collapsed-width);\n  }\n}\n.page-wrapper .page-content {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n\n@media (max-width: 1199.98px) {\n  body[data-sidebar-size=collapsed] .startbar {\n    margin-right: calc(var(--bs-startbar-width) * -1);\n  }\n  .page-wrapper .page-content {\n    margin-right: 0;\n  }\n  body[data-sidebar-size=default] .brand {\n    width: var(--bs-startbar-width);\n  }\n  body[data-sidebar-size=default] .brand .logo {\n    display: block;\n  }\n  body[data-sidebar-size=default] .brand .logo .logo-lg {\n    width: auto;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .menu-label {\n    text-align: start;\n    border-color: transparent;\n    font-weight: 400;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .menu-label span {\n    display: inline-block;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .menu-label small {\n    display: none;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link {\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: start;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link span {\n    display: inline-block;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after, body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link[data-bs-toggle=true]:after {\n    display: inline-block;\n  }\n  body[data-sidebar-size=default] .startbar-menu .navbar-nav .nav-item .nav-link .menu-icon {\n    margin-left: 8px;\n  }\n  body[data-sidebar-size=default] .page-wrapper .page-content {\n    width: 100%;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    margin-right: 0;\n  }\n}\n.update-msg {\n  border-radius: 5px;\n  padding: 1.5rem 12px;\n  margin: 50px 16px 16px;\n  position: relative;\n  background-color: rgba(49, 103, 243, 0.08);\n}\n.update-msg h5 {\n  color: var(--bs-menu-link-color);\n  font-weight: 700;\n}\n.update-msg .update-icon-box {\n  background-color: var(--bs-startbar-bg);\n  border: 5px solid rgba(49, 103, 243, 0.08);\n  margin-top: -40px;\n}\n.update-msg a.btn {\n  background-color: var(--bs-startbar-bg);\n}\n\n.startbar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(33, 37, 41, 0.35);\n  z-index: 1003;\n  display: none;\n}\n\n.startbar-enable .startbar-overlay {\n  display: block;\n}\n\n@media (max-width: 1199.98px) {\n  [data-sidebar-size=default] .startbar-overlay {\n    display: block;\n  }\n}\n[dir=rtl] .startbar .nav-link[data-bs-toggle=collapse]:after {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.label-border {\n  margin: 12px 0;\n}\n.label-border .border_left {\n  display: inline;\n  position: relative;\n}\n.label-border .border_left:before {\n  content: \"\";\n  display: inline-block;\n  border-bottom: 2px solid rgba(49, 103, 243, 0.2);\n  width: 20px;\n  position: relative;\n  top: -7px;\n}\n.label-border .border_left:after {\n  content: \"\";\n  display: inline-block;\n  border-bottom: 2px solid rgba(49, 103, 243, 0.5);\n  width: 6px;\n  position: absolute;\n  top: 7px;\n  right: 0;\n}\n.label-border .border_right {\n  display: inline;\n  position: relative;\n}\n.label-border .border_right:before {\n  content: \"\";\n  display: inline-block;\n  border-bottom: 2px solid rgba(49, 103, 243, 0.2);\n  width: 20px;\n  position: relative;\n  top: -1px;\n}\n.label-border .border_right:after {\n  content: \"\";\n  display: inline-block;\n  border-bottom: 2px solid rgba(49, 103, 243, 0.5);\n  width: 6px;\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n}\n\n.topbar {\n  height: var(--bs-topbar-height);\n  width: calc(100% - var(--bs-startbar-width));\n  margin-right: auto;\n  position: fixed;\n  right: 0;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: var(--bs-topbar-bg);\n  padding: 0 0.75rem;\n  border-bottom: 1px solid var(--bs-topbar-b-border-color);\n}\n.topbar .topbar-custom {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.topbar .topbar-custom:last-child ul li:last-child .nav-icon {\n  margin-right: 0;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.topbar .topbar-custom .topbar-item {\n  height: var(--bs-topbar-height);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.topbar .topbar-custom .nav-link {\n  margin: 0 5px;\n}\n.topbar .topbar-custom .nav-link.mobile-menu-btn {\n  margin-left: 0;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.topbar .topbar-custom .nav-link.nav-icon {\n  width: 36px;\n  height: 36px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 50%;\n}\n.topbar .topbar-custom .nav-link.nav-icon i {\n  font-size: 24px;\n  color: var(--bs-topbar-nav-icon-color);\n}\n.topbar .app-search {\n  position: relative;\n  margin: 0;\n}\n.topbar .app-search form {\n  position: relative;\n  z-index: 1;\n}\n.topbar .app-search form .form-control,\n.topbar .app-search form .form-control:focus {\n  border: 1px solid var(--bs-topbar-b-border-color);\n  font-size: 13px;\n  height: 42px;\n  background: var(--bs-topbar-nav-icon-bg);\n  width: 300px;\n  border-radius: 30px;\n  padding-left: 48px;\n  margin: 0 8px;\n}\n.topbar .app-search form button {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  left: 16px;\n  top: 50%;\n  font-size: 22px;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  border: none;\n  text-align: center;\n  background-color: transparent;\n  color: var(--bs-topbar-nav-icon-color);\n}\n.topbar .app-search form button i {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.topbar .app-search form button:focus {\n  outline: none;\n}\n.topbar .app-search ::-webkit-input-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n  font-weight: 400;\n}\n.topbar .app-search ::-moz-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n  font-weight: 400;\n}\n.topbar .app-search :-ms-input-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n  font-weight: 400;\n}\n.topbar .app-search ::-ms-input-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n  font-weight: 400;\n}\n.topbar .app-search ::placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n  font-weight: 400;\n}\n.topbar .app-search input.form-control:-moz-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n}\n.topbar .app-search input.form-control::-moz-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n}\n.topbar .app-search input.form-control:-ms-input-placeholder {\n  color: var(--bs-topbar-nav-icon-color);\n}\n\nhtml[data-bs-theme=dark] .topbar .topbar-custom .nav-link.nav-icon .light-mode {\n  display: none;\n}\nhtml[data-bs-theme=dark] .topbar .topbar-custom .nav-link.nav-icon .dark-mode {\n  display: inline-block;\n}\n\nhtml[data-bs-theme=light] .topbar .topbar-custom .nav-link.nav-icon .light-mode {\n  display: inline-block;\n}\nhtml[data-bs-theme=light] .topbar .topbar-custom .nav-link.nav-icon .dark-mode {\n  display: none;\n}\n\n@media (min-width: 1023.98px) {\n  body[data-sidebar-size=collapsed] .topbar {\n    width: calc(100% - var(--bs-startbar-collapsed-width));\n  }\n  .welcome-text {\n    display: inline-block;\n  }\n}\n@media (max-width: 1024px) {\n  body[data-sidebar-size=collapsed] .topbar,\n  body[data-sidebar-size=default] .topbar {\n    width: 100%;\n  }\n  .welcome-text {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .hide-phone {\n    display: none !important;\n  }\n  .topbar .topbar-custom .nav-link {\n    margin: 0 4px;\n  }\n  .topbar .topbar-custom.nav-sticky .nav-link.mobile-menu-btn {\n    margin-left: 4px;\n  }\n  .topbar .topbar-custom.nav-sticky:last-child ul li:last-child .nav-icon {\n    margin-right: 4px;\n  }\n}\n@media (max-width: 380px) {\n  .topbar .topbar-custom {\n    margin: 0;\n  }\n}\n.dropdown-icon-item {\n  display: block;\n  border-radius: 3px;\n  line-height: 36px;\n  text-align: center;\n  padding: 16px 0 8px;\n  border: 1px solid transparent;\n  color: var(--bs-body-color);\n}\n.dropdown-icon-item img {\n  height: 36px;\n}\n.dropdown-icon-item span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n}\n.dropdown-icon-item:hover {\n  background-color: #fff;\n}\n\n/*\nTemplate Name: Approx - Admin & Dashboard Template\nAuthor: Mannatthemes\nVersion: 2.2.0\nFile: footer Css\n*/\n.footer {\n  bottom: 0;\n  position: absolute;\n  right: 0;\n  left: 0;\n  background-color: var(--bs-body-bg);\n}\n\n.chat-box-left {\n  float: left;\n  width: 340px;\n  height: 710px;\n  background-color: var(--bs-secondary-bg);\n  border-radius: 8px;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n.chat-box-left .chat-body-left {\n  height: 556px;\n}\n\n.chat-box-right {\n  width: auto;\n  background-color: var(--bs-body-bg);\n  display: block;\n  border-radius: 8px;\n  position: relative;\n  height: 710px;\n  margin-left: 361px;\n  margin-bottom: 20px;\n}\n.chat-box-right .chat-body {\n  padding: 16px;\n  height: 540px;\n}\n.chat-box-right .chat-body .chat-detail {\n  max-height: 610px;\n}\n.chat-box-right .chat-body .chat-detail .chat-box .user-chat p {\n  background-color: var(--bs-secondary-bg);\n  -webkit-box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);\n          box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);\n  border-radius: 16px 16px 16px 0;\n  padding: 14px;\n  margin-bottom: 4px;\n  width: 75%;\n  max-width: max-content;\n}\n.chat-box-right .chat-body .chat-detail .chat-box.reverse {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.chat-box-right .chat-body .chat-detail .chat-box.reverse .user-chat {\n  display: contents;\n  width: 100%;\n}\n.chat-box-right .chat-body .chat-detail .chat-box.reverse .user-chat p {\n  background-color: #3167f3;\n  color: #ffffff;\n  border-radius: 16px 16px 0 16px;\n  text-align: end;\n}\n.chat-box-right .chat-body .chat-detail .chat-box .chat-time {\n  font-size: 10px;\n}\n.chat-box-right .chat-footer {\n  background-color: var(--bs-secondary-bg);\n  border-radius: 8px;\n  padding: 16px;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n}\n.chat-box-right .chat-footer .chat-features a {\n  color: #c1cde0;\n  font-size: 22px;\n  margin-left: 12px;\n}\n.chat-box-right .chat-footer .chat-features a:hover {\n  color: #3167f3;\n}\n.chat-box-right .chat-footer input.form-control {\n  border: none;\n}\n\n@media (min-width: 1024px) and (max-width: 1680px) {\n  .chat-box-left {\n    width: 310px;\n    float: left;\n  }\n  .chat-box-right {\n    width: auto;\n    margin-left: 330px;\n  }\n}\n@media (min-width: 767px) and (max-width: 1023.98px) {\n  .chat-box-left {\n    width: 100%;\n    float: none;\n  }\n  .chat-box-right {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n@media (max-width: 767px) {\n  .chat-box-left {\n    float: none;\n    width: 100%;\n  }\n  .chat-box-right {\n    margin: 0;\n    width: 100%;\n  }\n}\n@media (max-width: 660px) {\n  .chat-box-left {\n    float: none;\n    width: 100%;\n  }\n  .chat-box-right {\n    margin: 0;\n    width: 100%;\n  }\n}\n@media (max-width: 568px) {\n  .chat-box-left {\n    float: none;\n    width: 100%;\n  }\n  .chat-box-right {\n    margin: 0;\n    width: 100%;\n  }\n}\n.kanban-board {\n  margin-bottom: 0.75rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  overflow-x: auto;\n  padding-bottom: 1rem;\n}\n.kanban-board .kanban-col {\n  -webkit-margin-end: 1.5rem;\n          margin-inline-end: 1.5rem;\n  position: relative;\n  width: 100%;\n  min-width: 20rem;\n}\n.kanban-board .kanban-col:last-child {\n  -webkit-margin-end: 0;\n          margin-inline-end: 0;\n}\n.kanban-board .kanban-col .add-btn {\n  display: none;\n  position: relative;\n}\n.kanban-board .kanban-col:hover .add-btn {\n  display: inline-block;\n}\n\n.pricing-content li {\n  margin-bottom: 14px;\n  font-weight: 500;\n  color: #7a82b1;\n}\n.pricing-content li:before {\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 600;\n  font-size: 9px;\n  text-align: center;\n  background-color: rgba(49, 103, 243, 0.1);\n  color: #3167f3;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n\n.animate-blink {\n  -webkit-animation: a-animate-blink 1s step-start 0s infinite;\n  animation: a-animate-blink 1s step-start 0s infinite;\n  -webkit-animation-fill-mode: initial;\n          animation-fill-mode: initial;\n}\n\n@-webkit-keyframes a-animate-blink {\n  50% {\n    opacity: 0;\n  }\n}\n@keyframes a-animate-blink {\n  50% {\n    opacity: 0;\n  }\n}\n@media print {\n  .page-wrapper .page-content {\n    width: 100%;\n    margin-top: 0;\n  }\n}\n.starability-basic,\n.starability-growRotate,\n.starability-grow,\n.starability-fade,\n.starability-slot,\n.starability-checkmark {\n  min-height: auto;\n}\n.starability-basic > input:checked + label,\n.starability-basic > input:focus + label,\n.starability-growRotate > input:checked + label,\n.starability-growRotate > input:focus + label,\n.starability-grow > input:checked + label,\n.starability-grow > input:focus + label,\n.starability-fade > input:checked + label,\n.starability-fade > input:focus + label,\n.starability-slot > input:checked + label,\n.starability-slot > input:focus + label,\n.starability-checkmark > input:checked + label,\n.starability-checkmark > input:focus + label {\n  outline: none;\n  text-decoration: none;\n}\n\n.ribbon1 {\n  position: absolute;\n  top: -6.1px;\n  right: 10px;\n}\n.ribbon1:after {\n  position: absolute;\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-left: 30px solid transparent;\n  border-right: 30px solid transparent;\n  border-top: 10px solid;\n}\n.ribbon1 span {\n  display: block;\n  padding: 6px 4px 0px;\n  border-top-right-radius: 6px;\n  width: 60px;\n  font-size: 11px;\n  font-weight: 500;\n}\n.ribbon1 span:before, .ribbon1 span:after {\n  position: absolute;\n  content: \"\";\n}\n.ribbon1 span:before {\n  height: 6px;\n  width: 4px;\n  left: -4px;\n  top: 0;\n}\n.ribbon1 span:after {\n  height: 6px;\n  width: 6px;\n  left: -6px;\n  top: 0;\n  border-radius: 8px 8px 0 0;\n}\n.ribbon1 span.rib1-primary, .ribbon1 span:before {\n  background: #3167f3;\n}\n.ribbon1 span.rib1-primary:after {\n  background: #0c41cc;\n}\n.ribbon1 span.rib1-secondary, .ribbon1 span:before {\n  background: #a8b5d1;\n}\n.ribbon1 span.rib1-secondary:after {\n  background: #768ab7;\n}\n.ribbon1 span.rib1-success, .ribbon1 span:before {\n  background: #0da684;\n}\n.ribbon1 span.rib1-success:after {\n  background: #075f4c;\n}\n.ribbon1 span.rib1-info, .ribbon1 span:before {\n  background: #41cbd8;\n}\n.ribbon1 span.rib1-info:after {\n  background: #239eaa;\n}\n.ribbon1 span.rib1-warning, .ribbon1 span:before {\n  background: #f4a14d;\n}\n.ribbon1 span.rib1-warning:after {\n  background: #e67b0e;\n}\n.ribbon1 span.rib1-danger, .ribbon1 span:before {\n  background: #ef3463;\n}\n.ribbon1 span.rib1-danger:after {\n  background: #c7103e;\n}\n.ribbon1 span.rib1-pink, .ribbon1 span:before {\n  background: #fd3c97;\n}\n.ribbon1 span.rib1-pink:after {\n  background: #ea0270;\n}\n.ribbon1 span.rib1-purple, .ribbon1 span:before {\n  background: #5b58e6;\n}\n.ribbon1 span.rib1-purple:after {\n  background: #231fd2;\n}\n.ribbon1 span.rib1-blue, .ribbon1 span:before {\n  background: #3167f3;\n}\n.ribbon1 span.rib1-blue:after {\n  background: #0c41cc;\n}\n.ribbon1 span.rib1-light, .ribbon1 span:before {\n  background: #f4f6f9;\n}\n.ribbon1 span.rib1-light:after {\n  background: #c3cede;\n}\n.ribbon1 span.rib1-dark, .ribbon1 span:before {\n  background: #25282d;\n}\n.ribbon1 span.rib1-dark:after {\n  background: #020303;\n}\n.ribbon1.rib1-primary:after {\n  border-top-color: #3167f3;\n}\n.ribbon1.rib1-secondary:after {\n  border-top-color: #a8b5d1;\n}\n.ribbon1.rib1-success:after {\n  border-top-color: #0da684;\n}\n.ribbon1.rib1-info:after {\n  border-top-color: #41cbd8;\n}\n.ribbon1.rib1-warning:after {\n  border-top-color: #f4a14d;\n}\n.ribbon1.rib1-danger:after {\n  border-top-color: #ef3463;\n}\n.ribbon1.rib1-pink:after {\n  border-top-color: #fd3c97;\n}\n.ribbon1.rib1-purple:after {\n  border-top-color: #5b58e6;\n}\n.ribbon1.rib1-blue:after {\n  border-top-color: #3167f3;\n}\n.ribbon1.rib1-light:after {\n  border-top-color: #f4f6f9;\n}\n.ribbon1.rib1-dark:after {\n  border-top-color: #25282d;\n}\n\n.ribbon2 {\n  width: 30px;\n  padding: 8px 0;\n  position: absolute;\n  top: -6px;\n  right: 12px;\n  text-align: center;\n  border-top-left-radius: 3px;\n}\n.ribbon2:before, .ribbon2:after {\n  content: \"\";\n  position: absolute;\n}\n.ribbon2:before {\n  height: 0;\n  width: 0;\n  right: -5.5px;\n  top: 0.1px;\n  border-right: 6px solid transparent;\n}\n.ribbon2:after {\n  height: 0;\n  width: 0;\n  bottom: -18px;\n  left: 0;\n  border-bottom: 18px solid transparent;\n}\n.ribbon2.rib2-primary {\n  background: #3167f3;\n}\n.ribbon2.rib2-primary:before {\n  border-bottom: 6px solid #0c41cc;\n}\n.ribbon2.rib2-primary:after {\n  border-left: 15px solid #3167f3;\n  border-right: 15px solid #3167f3;\n}\n.ribbon2.rib2-secondary {\n  background: #a8b5d1;\n}\n.ribbon2.rib2-secondary:before {\n  border-bottom: 6px solid #768ab7;\n}\n.ribbon2.rib2-secondary:after {\n  border-left: 15px solid #a8b5d1;\n  border-right: 15px solid #a8b5d1;\n}\n.ribbon2.rib2-success {\n  background: #0da684;\n}\n.ribbon2.rib2-success:before {\n  border-bottom: 6px solid #075f4c;\n}\n.ribbon2.rib2-success:after {\n  border-left: 15px solid #0da684;\n  border-right: 15px solid #0da684;\n}\n.ribbon2.rib2-info {\n  background: #41cbd8;\n}\n.ribbon2.rib2-info:before {\n  border-bottom: 6px solid #239eaa;\n}\n.ribbon2.rib2-info:after {\n  border-left: 15px solid #41cbd8;\n  border-right: 15px solid #41cbd8;\n}\n.ribbon2.rib2-warning {\n  background: #f4a14d;\n}\n.ribbon2.rib2-warning:before {\n  border-bottom: 6px solid #e67b0e;\n}\n.ribbon2.rib2-warning:after {\n  border-left: 15px solid #f4a14d;\n  border-right: 15px solid #f4a14d;\n}\n.ribbon2.rib2-danger {\n  background: #ef3463;\n}\n.ribbon2.rib2-danger:before {\n  border-bottom: 6px solid #c7103e;\n}\n.ribbon2.rib2-danger:after {\n  border-left: 15px solid #ef3463;\n  border-right: 15px solid #ef3463;\n}\n.ribbon2.rib2-pink {\n  background: #fd3c97;\n}\n.ribbon2.rib2-pink:before {\n  border-bottom: 6px solid #ea0270;\n}\n.ribbon2.rib2-pink:after {\n  border-left: 15px solid #fd3c97;\n  border-right: 15px solid #fd3c97;\n}\n.ribbon2.rib2-purple {\n  background: #5b58e6;\n}\n.ribbon2.rib2-purple:before {\n  border-bottom: 6px solid #231fd2;\n}\n.ribbon2.rib2-purple:after {\n  border-left: 15px solid #5b58e6;\n  border-right: 15px solid #5b58e6;\n}\n.ribbon2.rib2-blue {\n  background: #3167f3;\n}\n.ribbon2.rib2-blue:before {\n  border-bottom: 6px solid #0c41cc;\n}\n.ribbon2.rib2-blue:after {\n  border-left: 15px solid #3167f3;\n  border-right: 15px solid #3167f3;\n}\n.ribbon2.rib2-light {\n  background: #f4f6f9;\n}\n.ribbon2.rib2-light:before {\n  border-bottom: 6px solid #c3cede;\n}\n.ribbon2.rib2-light:after {\n  border-left: 15px solid #f4f6f9;\n  border-right: 15px solid #f4f6f9;\n}\n.ribbon2.rib2-dark {\n  background: #25282d;\n}\n.ribbon2.rib2-dark:before {\n  border-bottom: 6px solid #020303;\n}\n.ribbon2.rib2-dark:after {\n  border-left: 15px solid #25282d;\n  border-right: 15px solid #25282d;\n}\n\n.ribbon3 {\n  text-align: center;\n  width: 70px;\n  height: 26px;\n  line-height: 26px;\n  padding-right: 12px;\n  position: absolute;\n  right: -8px;\n  top: 10px;\n  font-size: 11px;\n  font-weight: 500;\n}\n.ribbon3:before, .ribbon3:after {\n  content: \"\";\n  position: absolute;\n}\n.ribbon3:before {\n  height: 0;\n  width: 0;\n  bottom: -8.5px;\n  right: 0.1px;\n  border-right: 9px solid transparent;\n}\n.ribbon3:after {\n  height: 0;\n  width: 0;\n  left: -14.5px;\n  border-bottom: 13px solid transparent;\n  border-top: 13px solid transparent;\n}\n.ribbon3.rib3-primary {\n  background: #3167f3;\n}\n.ribbon3.rib3-primary:before {\n  border-top: 9px solid #0c41cc;\n}\n.ribbon3.rib3-primary:after {\n  border-right: 15px solid #3167f3;\n}\n.ribbon3.rib3-secondary {\n  background: #a8b5d1;\n}\n.ribbon3.rib3-secondary:before {\n  border-top: 9px solid #768ab7;\n}\n.ribbon3.rib3-secondary:after {\n  border-right: 15px solid #a8b5d1;\n}\n.ribbon3.rib3-success {\n  background: #0da684;\n}\n.ribbon3.rib3-success:before {\n  border-top: 9px solid #075f4c;\n}\n.ribbon3.rib3-success:after {\n  border-right: 15px solid #0da684;\n}\n.ribbon3.rib3-info {\n  background: #41cbd8;\n}\n.ribbon3.rib3-info:before {\n  border-top: 9px solid #239eaa;\n}\n.ribbon3.rib3-info:after {\n  border-right: 15px solid #41cbd8;\n}\n.ribbon3.rib3-warning {\n  background: #f4a14d;\n}\n.ribbon3.rib3-warning:before {\n  border-top: 9px solid #e67b0e;\n}\n.ribbon3.rib3-warning:after {\n  border-right: 15px solid #f4a14d;\n}\n.ribbon3.rib3-danger {\n  background: #ef3463;\n}\n.ribbon3.rib3-danger:before {\n  border-top: 9px solid #c7103e;\n}\n.ribbon3.rib3-danger:after {\n  border-right: 15px solid #ef3463;\n}\n.ribbon3.rib3-pink {\n  background: #fd3c97;\n}\n.ribbon3.rib3-pink:before {\n  border-top: 9px solid #ea0270;\n}\n.ribbon3.rib3-pink:after {\n  border-right: 15px solid #fd3c97;\n}\n.ribbon3.rib3-purple {\n  background: #5b58e6;\n}\n.ribbon3.rib3-purple:before {\n  border-top: 9px solid #231fd2;\n}\n.ribbon3.rib3-purple:after {\n  border-right: 15px solid #5b58e6;\n}\n.ribbon3.rib3-blue {\n  background: #3167f3;\n}\n.ribbon3.rib3-blue:before {\n  border-top: 9px solid #0c41cc;\n}\n.ribbon3.rib3-blue:after {\n  border-right: 15px solid #3167f3;\n}\n.ribbon3.rib3-light {\n  background: #f4f6f9;\n}\n.ribbon3.rib3-light:before {\n  border-top: 9px solid #c3cede;\n}\n.ribbon3.rib3-light:after {\n  border-right: 15px solid #f4f6f9;\n}\n.ribbon3.rib3-dark {\n  background: #25282d;\n}\n.ribbon3.rib3-dark:before {\n  border-top: 9px solid #020303;\n}\n.ribbon3.rib3-dark:after {\n  border-right: 15px solid #25282d;\n}\n\n.ribbon4 {\n  width: 100%;\n  height: 188px;\n  position: absolute;\n  top: -8px;\n  left: 8px;\n  overflow: hidden;\n}\n.ribbon4:before, .ribbon4:after {\n  content: \"\";\n  position: absolute;\n}\n.ribbon4:before {\n  width: 40px;\n  height: 8px;\n  right: 44px;\n  border-radius: 8px 8px 0px 0px;\n}\n.ribbon4:after {\n  width: 8px;\n  height: 40px;\n  right: 0px;\n  top: 44px;\n  border-radius: 0px 8px 8px 0px;\n}\n.ribbon4.rib4-primary:after, .ribbon4.rib4-primary:before {\n  background: #0d49e4;\n}\n.ribbon4.rib4-secondary:after, .ribbon4.rib4-secondary:before {\n  background: #8799bf;\n}\n.ribbon4.rib4-success:after, .ribbon4.rib4-success:before {\n  background: #09775e;\n}\n.ribbon4.rib4-info:after, .ribbon4.rib4-info:before {\n  background: #27b2bf;\n}\n.ribbon4.rib4-warning:after, .ribbon4.rib4-warning:before {\n  background: #f1881d;\n}\n.ribbon4.rib4-danger:after, .ribbon4.rib4-danger:before {\n  background: #de1245;\n}\n.ribbon4.rib4-pink:after, .ribbon4.rib4-pink:before {\n  background: #fc0a7c;\n}\n.ribbon4.rib4-purple:after, .ribbon4.rib4-purple:before {\n  background: #2f2cdf;\n}\n.ribbon4.rib4-blue:after, .ribbon4.rib4-blue:before {\n  background: #0d49e4;\n}\n.ribbon4.rib4-light:after, .ribbon4.rib4-light:before {\n  background: #d3dbe7;\n}\n.ribbon4.rib4-dark:after, .ribbon4.rib4-dark:before {\n  background: #0e0f11;\n}\n.ribbon4 .ribbon4-band {\n  width: 170px;\n  height: 20px;\n  line-height: 20px;\n  position: absolute;\n  top: 16px;\n  right: -50px;\n  z-index: 2;\n  overflow: hidden;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  border: 1px dashed;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 500;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-primary {\n  -webkit-box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #3167f3;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-secondary {\n  -webkit-box-shadow: 0 0 0 3px #a8b5d1, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #a8b5d1, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #a8b5d1;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-success {\n  -webkit-box-shadow: 0 0 0 3px #0da684, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #0da684, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #0da684;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-info {\n  -webkit-box-shadow: 0 0 0 3px #41cbd8, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #41cbd8, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #41cbd8;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-warning {\n  -webkit-box-shadow: 0 0 0 3px #f4a14d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #f4a14d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #f4a14d;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-danger {\n  -webkit-box-shadow: 0 0 0 3px #ef3463, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #ef3463, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #ef3463;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-pink {\n  -webkit-box-shadow: 0 0 0 3px #fd3c97, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #fd3c97, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #fd3c97;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-purple {\n  -webkit-box-shadow: 0 0 0 3px #5b58e6, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #5b58e6, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #5b58e6;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-blue {\n  -webkit-box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #3167f3, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #3167f3;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-light {\n  -webkit-box-shadow: 0 0 0 3px #f4f6f9, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #f4f6f9, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #f4f6f9;\n}\n.ribbon4 .ribbon4-band.ribbon4-band-dark {\n  -webkit-box-shadow: 0 0 0 3px #25282d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n          box-shadow: 0 0 0 3px #25282d, 0px 21px 5px -18px rgba(122, 130, 177, 0.6);\n  background: #25282d;\n}\n\n.activity .activity-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 5px 0;\n  position: relative;\n  min-height: 60px;\n}\n.activity .activity-info::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  top: 42px;\n  left: 18px;\n  border-left: 2px dotted var(--bs-border-color);\n}\n.activity .activity-info .icon-info-activity i {\n  width: 36px;\n  height: 36px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  border-radius: 50%;\n  color: var(--bs-secondary-color);\n  -webkit-box-shadow: 0px 0px 1px 0.25px;\n          box-shadow: 0px 0px 1px 0.25px;\n  font-size: 18px;\n  border: 1px solid var(--bs-border-color);\n  margin-left: 2px;\n}\n.activity .activity-info .activity-info-text {\n  margin-left: 16px;\n  width: 100%;\n}\n.activity .activity-info .activity-info-text a,\n.activity .activity-info .activity-info-text span {\n  color: #7a82b1;\n}\n\n.icon-item {\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 2.5rem;\n  width: 2.5rem;\n}\n\n.icon-item.icon-item-md {\n  height: 2.5rem;\n  width: 2.5rem;\n}\n\n.tracking-item {\n  border-left: 1px solid var(--bs-border-color);\n  position: relative;\n  padding: 24px 30px;\n  margin-left: 150px;\n}\n.tracking-item .tracking-date {\n  position: absolute;\n  left: -160px;\n  width: 120px;\n  text-align: right;\n  font-weight: 500;\n  font-size: 12px;\n}\n.tracking-item .tracking-icon {\n  line-height: 18px;\n  position: absolute;\n  left: -9px;\n  width: 18px;\n  height: 18px;\n  text-align: center;\n  border-radius: 50%;\n  background-color: var(--bs-secondary-bg);\n}\n.tracking-item .tracking-icon.icon-inner {\n  color: #a8b5d1;\n  font-size: 4px;\n  -webkit-box-shadow: 0px 0px 1px 1px #c1cde0;\n          box-shadow: 0px 0px 1px 1px #c1cde0;\n}\n\n.fc-event {\n  border-radius: 2px;\n  border: none;\n  cursor: move;\n  font-size: 13px;\n  margin: 5px;\n  padding: 7px 5px;\n  text-align: center;\n  background-color: rgba(49, 103, 243, 0.18);\n  color: #3167f3;\n}\n\n.fc .fc-header-toolbar.fc-toolbar .fc-toolbar-chunk h2 {\n  font-size: 16px;\n  text-transform: uppercase;\n  color: #3167f3;\n}\n.fc .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5rem;\n}\n.fc .fc-col-header-cell-cushion {\n  padding: 10px 0;\n  color: var(--bs-body-color);\n}\n.fc .fc-button {\n  font-size: 0.812rem;\n}\n.fc .fc-button-primary {\n  background: transparent;\n  border: 1px solid var(--bs-border-color);\n  color: #95a0c5;\n  text-transform: capitalize;\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.fc .fc-button-primary:hover {\n  background: #3167f3;\n  color: #ffffff;\n  border-color: var(--bs-border-color);\n}\n.fc .fc-button-primary.active, .fc .fc-button-primary:focus, .fc .fc-button-primary:active {\n  text-shadow: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.fc .fc-button-primary:disabled {\n  background: rgba(49, 103, 243, 0.1);\n  color: #3167f3;\n  border-color: var(--bs-border-color);\n  opacity: 1;\n}\n.fc .fc-button-primary:not(:disabled):active, .fc .fc-button-primary:not(:disabled).fc-button-active {\n  background: #3167f3;\n  color: #ffffff;\n  border-color: var(--bs-border-color);\n}\n.fc .fc-button-primary:not(:disabled):active:focus, .fc .fc-button-primary:not(:disabled).fc-button-active:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.fc .fc-daygrid-day-number {\n  color: var(--bs-body-color);\n  font-weight: 500;\n}\n.fc .fc-daygrid-day.fc-day-today {\n  background-color: transparent;\n  padding: 4px;\n  border-radius: 24px;\n}\n.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-frame {\n  background-color: rgba(49, 103, 243, 0.18);\n  border-radius: 8px;\n}\n.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-frame .fc-daygrid-day-number {\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.fc-license-message {\n  display: none;\n}\n\n.fc-theme-standard .fc-scrollgrid,\n.fc-theme-standard td,\n.fc-theme-standard th {\n  border: 1px solid var(--bs-border-color);\n}\n\n.fc-day-other {\n  background-image: linear-gradient(-45deg, var(--bs-secondary-bg) 25%, transparent 25%, transparent 50%, var(--bs-secondary-bg) 50%, rgba(122, 130, 177, 0.2) 75%, transparent 75%, transparent);\n  background-size: 10px 10px;\n}\n\n.fc-h-event .fc-event-main {\n  color: #3167f3;\n  font-weight: 500;\n}\n\n.fc-daygrid-dot-event .fc-event-title {\n  font-weight: 500;\n}\n\n.fc-direction-ltr .fc-daygrid-event.fc-event-start, .fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start,\n.fc-direction-rtl .fc-daygrid-event.fc-event-end {\n  background-color: var(--bs-card-bg);\n  -webkit-box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);\n          box-shadow: 0 2px 2px rgba(61, 71, 81, 0.05);\n  color: #3167f3;\n  border-radius: 4px;\n}\n\n[data-simplebar] {\n  position: relative;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  -webkit-box-sizing: inherit !important;\n          box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  -webkit-box-sizing: border-box !important;\n          box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: \" \";\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  -webkit-box-sizing: inherit !important;\n          box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  -webkit-box-flex: inherit;\n      -ms-flex-positive: inherit;\n          flex-grow: inherit;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  -webkit-box-sizing: inherit;\n          box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n}\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  min-height: 10px;\n}\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: \"\";\n  background: rgba(168, 181, 209, 0.5);\n  border-radius: 7px;\n  left: 2px;\n  right: 2px;\n  opacity: 0;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  -webkit-transition: opacity 0s linear;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 10px;\n}\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n/* Rtl support */\n[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.apexcharts-gridlines-horizontal,\n.apexcharts-gridlines-vertical,\n.apexcharts-grid,\n.apexcharts-gridline,\n.apexcharts-xaxis-tick,\n.apexcharts-xaxis line,\n.apexcharts-gridline line {\n  pointer-events: none;\n  stroke: var(--bs-border-color);\n}\n\n.apexcharts-xaxis line {\n  display: none;\n}\n\n.apexcharts-grid-borders line,\n.apexcharts-radar-series line,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-radar-series path,\n.apexcharts-radar-series polygon {\n  pointer-events: none;\n  stroke: var(--bs-border-color);\n}\n\n.apexcharts text, .apexcharts-data-labels text {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.apexcharts-legend-text {\n  color: var(--bs-heading-color) !important;\n  opacity: 0.8;\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.apexcharts-pie-label {\n  fill: #ffffff !important;\n}\n\n.apexcharts-xaxis text,\n.apexcharts-yaxis text {\n  font-family: var(--bs-font-sans-serif) !important;\n  fill: var(--bs-heading-color);\n  opacity: 0.8;\n}\n\n.apexcharts-datalabels text,\n.apexcharts-data-labels {\n  font-family: var(--bs-font-sans-serif) !important;\n  fill: var(--bs-heading-color);\n}\n\n.apexcharts-yaxis-annotation-label {\n  color: var(--bs-heading-color);\n  opacity: 0.8;\n}\n\n.apexcharts-point-annotations text,\n.apexcharts-xaxis-annotations text,\n.apexcharts-yaxis-annotations text {\n  fill: #ffffff;\n}\n\n.tick text {\n  font-family: var(--bs-font-sans-serif) !important;\n  font-size: 0.75rem;\n}\n\n.extended-x-line,\n.extended-y-line,\n.horizontal-grid-line,\n.vertical-grid-line {\n  stroke: #d9e1ec;\n}\n\n.bar-chart .percentage-label,\n.donut-text,\n.legend-entry-name,\n.legend-entry-value,\n.tick text {\n  fill: var(--bs-heading-color);\n  opacity: 0.8;\n}\n\n.apex-charts {\n  min-height: 10px;\n}\n\n.apexcharts-tooltip-title {\n  font-family: var(--bs-font-sans-serif) !important;\n  background: var(--bs-body-bg) !important;\n  color: var(--bs-body-color);\n  border-color: #f4f6f9;\n}\n\n.apexcharts-tooltip-text {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.apexcharts-tooltip {\n  font-family: var(--bs-font-sans-serif) !important;\n  background: var(--bs-body-bg) !important;\n  border-color: var(--bs-border-color) !important;\n  white-space: normal;\n}\n\n.apexcharts-xaxistooltip {\n  background-color: var(--bs-body-bg);\n  border-color: var(--bs-body-bg);\n  color: #25282d;\n}\n\n.apexcharts-xaxistooltip-top:before,\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: var(--bs-body-bg);\n}\n\n.apexcharts-xaxistooltip-bottom:before,\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: var(--bs-body-bg);\n}\n\n.apexcharts-xaxistooltip:before,\n.apexcharts-xaxistooltip:after {\n  border-color: var(--bs-body-bg);\n}\n\n.apexcharts-title-text,\n.apexcharts-datalabel-label {\n  color: var(--bs-heading-color);\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.apexcharts-datalabel-value {\n  color: #f4f6f9;\n}\n\n.apexcharts-legend-marker {\n  margin-right: 5px;\n  vertical-align: middle;\n  height: 5px;\n}\n\n.apexcharts-yaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,\n.apexcharts-yaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-xaxis-label,\n.apexcharts-yaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,\n.apexcharts-yaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-xaxis-label,\n.apexcharts-xaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,\n.apexcharts-xaxis .apexcharts-yaxis-texts-g .apexcharts-text.apexcharts-xaxis-label,\n.apexcharts-xaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-yaxis-label,\n.apexcharts-xaxis .apexcharts-xaxis-texts-g .apexcharts-text.apexcharts-xaxis-label {\n  font-weight: 500;\n}\n\n.apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-value, .apexcharts-datalabels-group .apexcharts-text.apexcharts-datalabel-label {\n  font-family: var(--bs-font-sans-serif) !important;\n  fill: var(--bs-heading-color);\n  opacity: 0.8;\n  color: var(--bs-heading-color);\n  opacity: 0.8;\n}\n\n.apexcharts-grid-row {\n  background-color: rgba(168, 181, 209, 0.2);\n}\n\n/*clock*/\n.superpose {\n  color: #eaeff5;\n  height: 350px;\n  width: 100%;\n}\n.superpose .superclock {\n  position: relative;\n  width: 300px;\n  margin: auto;\n}\n.superpose .superclock .superclock1 {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n}\n.superpose .superclock .superclock2 {\n  position: absolute;\n  left: 60px;\n  top: 60px;\n}\n.superpose .superclock .superclock3 {\n  position: absolute;\n  left: 110px;\n  top: 110px;\n}\n\n.drop-shadow {\n  -webkit-filter: drop-shadow(0px 8px 4px #f4f6f9);\n          filter: drop-shadow(0px 8px 4px #f4f6f9);\n}\n\n.tui-chart .tui-chart-chartExportMenu-area {\n  z-index: 50;\n}\n\n.pill-bar .apexcharts-bar-series.apexcharts-plot-series .apexcharts-series path {\n  -webkit-clip-path: inset(0 0 4% 0 round 30px);\n          clip-path: inset(0 0 4% 0 round 30px);\n}\n\n.gauge text {\n  fill: var(--bs-heading-color);\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.tui-chart .tui-chart-chartExportMenu-area .tui-chart-chartExportMenu-button {\n  display: none;\n}\n.tui-chart text {\n  fill: var(--bs-body-color);\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.gmaps {\n  height: 300px;\n  background: #f4f6f9;\n  border-radius: 3px;\n}\n\n.overlay {\n  display: block;\n  text-align: center;\n  color: #ffffff;\n  font-size: 14px;\n  line-height: 20px;\n  background: #3167f3;\n  border-radius: 4px;\n  padding: 5px 15px;\n}\n\n.overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.overlay_arrow.above {\n  bottom: -9px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #3167f3;\n}\n\n.overlay_arrow.below {\n  top: -9px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid #3167f3;\n}\n\n.svgMap-map-wrapper {\n  position: relative;\n  width: 100%;\n  padding-top: 50%;\n  overflow: hidden;\n  background: #f4f6f9;\n}\n\n.jvm-container text {\n  font-family: var(--bs-font-sans-serif) !important;\n  fill: var(--bs-heading-color) !important;\n}\n\n.jvm-tooltip {\n  background-color: #3167f3;\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  color: #9efeff;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  -moz-tab-size: 4;\n    -o-tab-size: 4;\n       tab-size: 4;\n  -ms-hyphens: none;\n      hyphens: none;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n  text-shadow: 0 1px #222245;\n}\n\ncode[class*=language-] ::-moz-selection, code[class*=language-]::-moz-selection, pre[class*=language-] ::-moz-selection, pre[class*=language-]::-moz-selection {\n  color: inherit;\n  background: #a599e9;\n}\n\ncode[class*=language-] ::-moz-selection,\ncode[class*=language-] ::selection,\ncode[class*=language-]::-moz-selection,\ncode[class*=language-]::selection,\npre[class*=language-] ::-moz-selection,\npre[class*=language-] ::selection,\npre[class*=language-]::-moz-selection,\npre[class*=language-]::selection {\n  color: inherit;\n  background: #a599e9;\n}\n\npre[class*=language-] {\n  padding: 2em;\n  margin: 0;\n  overflow: auto;\n}\n\n:not(pre) > code[class*=language-],\npre[class*=language-] {\n  background: #151516;\n}\n\n:not(pre) > code[class*=language-] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n}\n\n.token {\n  font-weight: 400;\n}\n\n.token.cdata,\n.token.comment,\n.token.prolog {\n  color: #b362ff;\n}\n\n.token.atrule,\n.token.delimiter,\n.token.important,\n.token.keyword,\n.token.selector {\n  color: #ff9d00;\n}\n\n.token.attr-name,\n.token.operator {\n  color: #ffb454;\n}\n\n.token.punctuation {\n  color: #fff;\n}\n\n.token.boolean {\n  color: #ff628c;\n}\n\n.token.builtin,\n.token.doctype,\n.token.tag,\n.token.tag .punctuation {\n  color: #ff9d00;\n}\n\n.token.entity,\n.token.symbol {\n  color: #6897bb;\n}\n\n.token.number {\n  color: #ff628c;\n}\n\n.token.constant,\n.token.property,\n.token.variable {\n  color: #ff628c;\n}\n\n.token.char,\n.token.string {\n  color: #a5ff90;\n}\n\n.token.attr-value,\n.token.attr-value .punctuation {\n  color: #a5c261;\n}\n\n.token.attr-value .punctuation:first-child {\n  color: #a9b7c6;\n}\n\n.token.url {\n  color: #287bde;\n  text-decoration: underline;\n}\n\n.token.function {\n  color: #fad000;\n}\n\n.token.regex {\n  background: #364135;\n}\n\n.token.bold {\n  font-weight: 700;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.inserted {\n  background: #0f0;\n}\n\n.token.deleted {\n  background: #ff000d;\n}\n\ncode.language-css .token.property,\ncode.language-css .token.property + .token.punctuation {\n  color: #a9b7c6;\n}\n\ncode.language-css .token.id {\n  color: #ffc66d;\n}\n\ncode.language-css .token.selector > .token.attribute,\ncode.language-css .token.selector > .token.class,\ncode.language-css .token.selector > .token.pseudo-class,\ncode.language-css .token.selector > .token.pseudo-element {\n  color: #ffc66d;\n}\n\n.token.class-name {\n  color: #fb94ff;\n}\n\n.language-css .token.string,\n.style .token.string,\n.token.entity,\n.token.operator,\n.token.url {\n  background: 0 0;\n}\n\n.line-highlight.line-highlight {\n  margin-top: 36px;\n  background: -webkit-gradient(linear, left top, right top, from(rgba(179, 98, 255, 0.17)), to(transparent));\n  background: linear-gradient(to right, rgba(179, 98, 255, 0.17), transparent);\n}\n\n.line-highlight.line-highlight:before,\n.line-highlight.line-highlight[data-end]:after {\n  content: \"\";\n}\n\npre.language-html,\npre.language-css,\npre.language-javascript {\n  max-height: 220px;\n  overflow-y: auto;\n}\npre.language-html::-webkit-scrollbar,\npre.language-css::-webkit-scrollbar,\npre.language-javascript::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\npre.language-html::-webkit-scrollbar:vertical,\npre.language-css::-webkit-scrollbar:vertical,\npre.language-javascript::-webkit-scrollbar:vertical {\n  width: 5px;\n  margin-right: 5px;\n}\npre.language-html::-webkit-scrollbar:horizontal,\npre.language-css::-webkit-scrollbar:horizontal,\npre.language-javascript::-webkit-scrollbar:horizontal {\n  height: 10px;\n}\npre.language-html::-webkit-scrollbar-thumb,\npre.language-css::-webkit-scrollbar-thumb,\npre.language-javascript::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  border-radius: 10px;\n  margin-right: 5px;\n  border: none;\n  -webkit-transition: all 0.4s ease-out;\n  transition: all 0.4s ease-out;\n}\npre.language-html::-webkit-scrollbar-track,\npre.language-css::-webkit-scrollbar-track,\npre.language-javascript::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: transparent;\n}\npre.language-html::-webkit-scrollbar-corner,\npre.language-css::-webkit-scrollbar-corner,\npre.language-javascript::-webkit-scrollbar-corner {\n  background: transparent;\n}\npre.language-html:hover::-webkit-scrollbar-thumb,\npre.language-css:hover::-webkit-scrollbar-thumb,\npre.language-javascript:hover::-webkit-scrollbar-thumb {\n  background-color: rgba(244, 246, 249, 0.3);\n  -webkit-transition: all 0.4s ease-out;\n  transition: all 0.4s ease-out;\n}\n\n.swal2-popup {\n  background: var(--bs-secondary-bg);\n  padding: 1.5rem 1.5rem;\n}\n.swal2-popup .swal2-title {\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--bs-body-color);\n}\n.swal2-popup .swal2-content {\n  color: #95a0c5;\n  font-size: 15px;\n}\n.swal2-popup.swal2-toast {\n  background-color: var(--bs-secondary-bg);\n  -webkit-box-shadow: 0 0 0.625em rgba(85, 91, 126, 0.2);\n          box-shadow: 0 0 0.625em rgba(85, 91, 126, 0.2);\n}\n.swal2-popup.swal2-toast .swal2-title {\n  line-height: 1.2;\n}\n.swal2-popup .swal2-styled {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-color: transparent;\n  border: none;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.8125rem;\n  border-radius: 0.25rem;\n}\n.swal2-popup .swal2-styled:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.swal2-popup .swal2-styled.swal2-confirm {\n  font-size: 0.812rem;\n  background-color: #0da684;\n}\n.swal2-popup .swal2-styled.swal2-confirm:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.swal2-popup .swal2-styled.swal2-deny {\n  background-color: #3167f3;\n  font-size: 0.812rem;\n}\n.swal2-popup .swal2-styled.swal2-deny:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.swal2-popup .swal2-styled.swal2-cancel {\n  font-size: 0.812rem;\n  background-color: #ef3463;\n}\n.swal2-popup .swal2-styled.swal2-cancel:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.swal2-close:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.swal2-footer {\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.swal2-actions .btn-success,\n.swal2-actions .btn-danger {\n  border: none;\n}\n.swal2-actions .btn-success:focus,\n.swal2-actions .btn-danger:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\ndiv:where(.swal2-container) .swal2-html-container {\n  color: var(--bs-text-muted);\n}\ndiv:where(.swal2-container) input:where(.swal2-input),\ndiv:where(.swal2-container) input:where(.swal2-file),\ndiv:where(.swal2-container) textarea:where(.swal2-textarea) {\n  border: 1px solid var(--bs-border-color);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: var(--bs-body-color);\n}\ndiv:where(.swal2-container) input:where(.swal2-input):focus,\ndiv:where(.swal2-container) input:where(.swal2-file):focus,\ndiv:where(.swal2-container) textarea:where(.swal2-textarea):focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: 1px solid #3167f3;\n}\n\n.swal2-icon {\n  width: 3em;\n  height: 3em;\n  margin: 1em auto 1em;\n}\n\n.swal2-icon.swal2-error [class^=swal2-x-mark-line] {\n  top: 22px;\n  width: 30px;\n}\n\n.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {\n  left: 9px;\n}\n\n.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right] {\n  right: 9px;\n}\n\n.swal2-icon .swal2-icon-content {\n  font-size: 40px;\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-circular-line] {\n  width: 40px;\n  height: 70px;\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left] {\n  top: -23px;\n  left: -13px;\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right] {\n  top: -12px;\n  left: 36px;\n}\n\n.swal2-icon.swal2-success .swal2-success-fix {\n  top: 0px;\n  left: 12px;\n  width: 6px;\n  height: 60px;\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip] {\n  top: 28px;\n  left: 6px;\n  width: 18px;\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-line][class$=long] {\n  top: 23px;\n  right: 4px;\n  width: 30px;\n}\n\n@-webkit-keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: 0.0625em;\n    width: 0;\n  }\n  54% {\n    top: 24px;\n    left: 4px;\n    width: 0;\n  }\n  70% {\n    top: 27px;\n    left: 0px;\n    width: 22px;\n  }\n  84% {\n    top: 30px;\n    left: 8px;\n    width: 16px;\n  }\n  100% {\n    top: 28px;\n    left: 6px;\n    width: 18px;\n  }\n}\n@keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: 0.0625em;\n    width: 0;\n  }\n  54% {\n    top: 24px;\n    left: 4px;\n    width: 0;\n  }\n  70% {\n    top: 27px;\n    left: 0px;\n    width: 22px;\n  }\n  84% {\n    top: 30px;\n    left: 8px;\n    width: 16px;\n  }\n  100% {\n    top: 28px;\n    left: 6px;\n    width: 18px;\n  }\n}\n@-webkit-keyframes swal2-animate-success-line-long {\n  0% {\n    top: 26px;\n    right: 10px;\n    width: 0;\n  }\n  65% {\n    top: 26px;\n    right: 10px;\n    width: 0;\n  }\n  84% {\n    top: 22px;\n    right: 0;\n    width: 34px;\n  }\n  100% {\n    top: 23px;\n    right: 4px;\n    width: 30px;\n  }\n}\n@keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n  65% {\n    top: 40px;\n    right: 30px;\n    width: 0;\n  }\n  84% {\n    top: 22px;\n    right: 0;\n    width: 34px;\n  }\n  100% {\n    top: 23px;\n    right: 4px;\n    width: 30px;\n  }\n}\n.noUi-target {\n  background: rgba(168, 181, 209, 0.2);\n  border-radius: 4px;\n  border: 1px solid var(--bs-border-color);\n  -webkit-box-shadow: inset 0 1px 1px rgba(168, 181, 209, 0.1), 0 3px 6px -5px rgba(168, 181, 209, 0.2);\n          box-shadow: inset 0 1px 1px rgba(168, 181, 209, 0.1), 0 3px 6px -5px rgba(168, 181, 209, 0.2);\n}\n\n.noUi-horizontal .noUi-handle {\n  width: 16px;\n  height: 16px;\n  right: -8px;\n  top: -6px;\n}\n\n.noUi-horizontal {\n  height: 7px;\n}\n\n/* Handle stripes;\n */\n.noUi-handle {\n  border: 2px solid var(--bs-border-color);\n  border-radius: 50px;\n  background: #3167f3;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.noUi-handle:before, .noUi-handle:after {\n  height: 4px;\n  width: 1px;\n  background: #ffffff;\n  left: 4px;\n  top: 4px;\n}\n\n.noUi-handle:after {\n  left: 7px;\n}\n\n.noUi-connect {\n  background: #2c5ddb;\n}\n\n.noUi-vertical {\n  width: 7px;\n}\n.noUi-vertical .noUi-handle {\n  width: 16px;\n  height: 16px;\n  right: -5.5px;\n  top: -10px;\n}\n.noUi-vertical .noUi-handle:before, .noUi-vertical .noUi-handle:after {\n  width: 5px;\n  height: 1px;\n  left: 3px;\n  top: 7px;\n}\n.noUi-vertical .noUi-handle:after {\n  width: 5px;\n  height: 1px;\n  left: 3px;\n  top: 4px;\n}\n.noUi-vertical .noUi-origin {\n  top: 0;\n}\n\n.noUi-marker {\n  position: absolute;\n  background: rgba(168, 181, 209, 0.2);\n}\n\n.noUi-marker-sub {\n  background: rgba(168, 181, 209, 0.3);\n}\n\n.noUi-marker-large {\n  background: rgba(168, 181, 209, 0.3);\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 12px;\n}\n\n.example-val:before {\n  content: \"Value: \";\n}\n\n.noUi-tooltip {\n  display: none;\n}\n\n.noUi-active .noUi-tooltip {\n  display: block;\n}\n\n.noUi-tooltip {\n  border: 1px solid var(--bs-border-color);\n  background: #fafbfc;\n  color: #7a82b1;\n  padding: 2px 4px;\n  font-size: 10px;\n}\n\nul.listree-submenu-items {\n  border-left: 1px dashed var(--bs-border-color);\n}\nul.listree-submenu-items li a {\n  margin-bottom: 12px;\n  display: block;\n}\n\n.folder-icon div.listree-submenu-heading.collapsed:before {\n  content: \"\\f07b\";\n  font-family: \"Font Awesome 5 Free\";\n}\n\n.folder-icon div.listree-submenu-heading.expanded:before {\n  content: \"\\f07c\";\n  font-family: \"Font Awesome 5 Free\";\n}\n\n[dir=rtl] ul.listree-submenu-items {\n  border-right: none;\n}\n\n.listree-submenu-heading {\n  padding-bottom: 12px;\n}\n\n.dynamic-select {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  width: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.dynamic-select .dynamic-select-header {\n  border: 1px solid #dee2e6;\n  padding: 7px 30px 7px 12px;\n}\n.dynamic-select .dynamic-select-header::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23949ba3' viewBox='0 0 16 16'%3E%3Cpath d='M8 13.1l-8-8 2.1-2.2 5.9 5.9 5.9-5.9 2.1 2.2z'/%3E%3C/svg%3E\");\n  height: 12px;\n  width: 12px;\n}\n.dynamic-select .dynamic-select-header.dynamic-select-header-active {\n  border-color: #c1c9d0;\n}\n.dynamic-select .dynamic-select-header.dynamic-select-header-active::after {\n  -webkit-transform: translateY(-50%) rotate(180deg);\n          transform: translateY(-50%) rotate(180deg);\n}\n.dynamic-select .dynamic-select-header.dynamic-select-header-active + .dynamic-select-options {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.dynamic-select .dynamic-select-header .dynamic-select-header-placeholder {\n  color: #65727e;\n}\n.dynamic-select .dynamic-select-options {\n  display: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  margin-top: 5px;\n  padding: 5px;\n  background-color: #fff;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.dynamic-select .dynamic-select-options::-webkit-scrollbar {\n  width: 5px;\n}\n.dynamic-select .dynamic-select-options::-webkit-scrollbar-track {\n  background: #f0f1f3;\n}\n.dynamic-select .dynamic-select-options::-webkit-scrollbar-thumb {\n  background: #cdcfd1;\n}\n.dynamic-select .dynamic-select-options::-webkit-scrollbar-thumb:hover {\n  background: #b2b6b9;\n}\n.dynamic-select .dynamic-select-options .dynamic-select-option {\n  padding: 7px 12px;\n}\n.dynamic-select .dynamic-select-options .dynamic-select-option:hover, .dynamic-select .dynamic-select-options .dynamic-select-option:active {\n  background-color: #f3f4f7;\n}\n.dynamic-select .dynamic-select-header, .dynamic-select .dynamic-select-option {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 45px;\n  font-size: 16px;\n  color: #212529;\n}\n.dynamic-select .dynamic-select-header img, .dynamic-select .dynamic-select-option img {\n  -o-object-fit: contain;\n     object-fit: contain;\n  max-height: 100%;\n  max-width: 100%;\n}\n.dynamic-select .dynamic-select-header img.dynamic-size, .dynamic-select .dynamic-select-option img.dynamic-size {\n  -o-object-fit: fill;\n     object-fit: fill;\n  max-height: none;\n  max-width: none;\n}\n.dynamic-select .dynamic-select-header img, .dynamic-select .dynamic-select-header svg, .dynamic-select .dynamic-select-header i, .dynamic-select .dynamic-select-header span, .dynamic-select .dynamic-select-option img, .dynamic-select .dynamic-select-option svg, .dynamic-select .dynamic-select-option i, .dynamic-select .dynamic-select-option span {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-right: 10px;\n}\n.dynamic-select .dynamic-select-header.dynamic-select-no-text, .dynamic-select .dynamic-select-option.dynamic-select-no-text {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.dynamic-select .dynamic-select-header.dynamic-select-no-text img, .dynamic-select .dynamic-select-header.dynamic-select-no-text svg, .dynamic-select .dynamic-select-header.dynamic-select-no-text i, .dynamic-select .dynamic-select-header.dynamic-select-no-text span, .dynamic-select .dynamic-select-option.dynamic-select-no-text img, .dynamic-select .dynamic-select-option.dynamic-select-no-text svg, .dynamic-select .dynamic-select-option.dynamic-select-no-text i, .dynamic-select .dynamic-select-option.dynamic-select-no-text span {\n  margin-right: 0;\n}\n.dynamic-select .dynamic-select-header .dynamic-select-option-text, .dynamic-select .dynamic-select-option .dynamic-select-option-text {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: inherit;\n  font-size: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
